import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import style from "./Profile.module.css";
import { baseurl, appUrl } from "../Url";
import { logActivity } from "../../services/activityService";
import { AiOutlineInfoCircle, AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";
import { MdClose, MdCheck, MdAdd, MdEdit, MdDelete, MdPlayCircle, MdInsertDriveFile, MdDownload, MdPerson, MdFlag, MdWarning, MdShare, MdMoreVert } from "react-icons/md";
import Loader from "../Loder/Loader";
import GoalsPopup from "../GoalsPopup/GoalsPopup";
import ToastPopup from "../ToastPopup/ToastPopup";

const Profile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { onMenuToggle } = useOutletContext() || {};
  const USERID = localStorage.getItem("USERID");
  const OrgID = localStorage.getItem("ORGID");
  const UserName = localStorage.getItem("username");
  const { userDetails, status: userStatus } = useSelector((state) => state.user);
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || "Bio");
  const [loading, setLoading] = useState(true);
  const fileInputRef = useRef(null);
  const imageInputRef = useRef(null);
  const companyInputRef = useRef(null);
  const videoInputRef = useRef(null);
  const documentInputRef = useRef(null);
  const storyVideoRefs = useRef({});
  const lastExperienceRef = useRef(null);
  const prevWorkExpLengthRef = useRef(0);
  const lastSkillRef = useRef(null);
  const prevSkillsLengthRef = useRef(0);
  // Prevent scrollIntoView during initial fetch/tab switching.
  // Only scroll when user explicitly clicks "Add skill".
  const pendingSkillAddScrollRef = useRef(false);

  // Profile Image
  const [profileImage, setProfileImage] = useState(null);
  const [profileImageUrl, setProfileImageUrl] = useState("");
  const [profileImagePreview, setProfileImagePreview] = useState("");

  // Resume tab data
  const [resumeFile, setResumeFile] = useState(null);
  const [resumeFileName, setResumeFileName] = useState("");
  const [resumeUploadDate, setResumeUploadDate] = useState("");
  const [resumeUrl, setResumeUrl] = useState("");
  const [summary, setSummary] = useState("");
  const [isSummaryEditing, setIsSummaryEditing] = useState(false);

  // Personal Information
  const [personalInfo, setPersonalInfo] = useState({
    fullName: "",
    email: "",
    phone: "",
    phoneCountryCode: "+91",
    city: "",
    country: "",
  });

  // Education
  const [education, setEducation] = useState([]);

  // Work Experience
  const [workExperience, setWorkExperience] = useState([]);
  const [isEditingExperience, setIsEditingExperience] = useState(false);

  // Projects
  const [projects, setProjects] = useState([]);

  // Links
  const [links, setLinks] = useState({
    name: "",
    url: "",
  });

  // Skills - each skill has { id, title, description }
  const [skills, setSkills] = useState([]);

  // Portfolio/Videos
  const [videos, setVideos] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [videoTitle, setVideoTitle] = useState("");
  const [videoDescription, setVideoDescription] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState("");
  const [videoSource, setVideoSource] = useState("upload"); // "upload" or "youtube"
  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [editingSkillId, setEditingSkillId] = useState(null);
  const [showVideoUploadModal, setShowVideoUploadModal] = useState(false);
  const [showGenerateResumeModal, setShowGenerateResumeModal] = useState(false);
  const [jobInput, setJobInput] = useState("");
  const [isGeneratingResume, setIsGeneratingResume] = useState(false);
  const [profileCompleted, setProfileCompleted] = useState(null);
  const [goalCompleted, setGoalCompleted] = useState(null);
  const [profileBannerDismissed, setProfileBannerDismissed] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(`profileBannerDismissed_${USERID}`) || "false");
    } catch { return false; }
  });
  const [goalBannerDismissed, setGoalBannerDismissed] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(`goalBannerDismissed_${USERID}`) || "false");
    } catch { return false; }
  });
  const [showGoalsPopup, setShowGoalsPopup] = useState(false);
  const [toastPopup, setToastPopup] = useState({ show: false, message: "", type: "success" });
  const [sharePopoverOpen, setSharePopoverOpen] = useState(false);
  const [sharedProfileUrl, setSharedProfileUrl] = useState("");
  const [showAllDocuments, setShowAllDocuments] = useState(false);
  const [showAllVideos, setShowAllVideos] = useState(false);
  const [downloadedDocUrls, setDownloadedDocUrls] = useState(new Set());
  const [storyVideoModal, setStoryVideoModal] = useState(null);
  const [docActionModal, setDocActionModal] = useState(null);
  const [docNameInput, setDocNameInput] = useState("");
  const [videoActionModal, setVideoActionModal] = useState(null);
  const [videoTitleInput, setVideoTitleInput] = useState("");
  const [videoDescriptionInput, setVideoDescriptionInput] = useState("");
  const [hoveredYoutubeKey, setHoveredYoutubeKey] = useState(null);

  const openResumeInNewTab = (fileUrl, fileName = "") => {
    if (!fileUrl) return;
    const normalizedName = String(fileName || "").toLowerCase();
    const normalizedUrl = String(fileUrl).toLowerCase();
    const isOfficeDoc =
      normalizedName.endsWith(".doc") ||
      normalizedName.endsWith(".docx") ||
      normalizedUrl.includes(".doc") ||
      normalizedUrl.includes(".docx");

    if (isOfficeDoc) {
      const officeViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(fileUrl)}`;
      window.open(officeViewerUrl, "_blank", "noopener,noreferrer");
      return;
    }

    const viewUrl = `${baseurl}/resume/view?url=${encodeURIComponent(fileUrl)}&filename=${encodeURIComponent(fileName || "resume")}`;
    window.open(viewUrl, "_blank", "noopener,noreferrer");
  };
  const pageRootRef = useRef(null);
  /** Set by setActiveTabPreserveScroll; applied in useLayoutEffect after tab DOM updates */
  const tabScrollRestoreRef = useRef(null);

  /** Nearest ancestor with vertical scroll (Layout uses .pageContent overflow-y: auto) */
  const findScrollContainer = (startEl) => {
    let el = startEl;
    while (el && el !== document.body) {
      const sty = window.getComputedStyle(el);
      const oy = sty?.overflowY;
      if (oy === "auto" || oy === "scroll" || oy === "overlay") {
        return el;
      }
      el = el.parentElement;
    }
    return document.scrollingElement || document.documentElement;
  };

  const setActiveTabPreserveScroll = (nextTab) => {
    const scroller = findScrollContainer(pageRootRef.current);
    tabScrollRestoreRef.current = {
      el: scroller,
      top: scroller?.scrollTop ?? 0,
    };
    setActiveTab(nextTab);
  };

  useLayoutEffect(() => {
    const pending = tabScrollRestoreRef.current;
    if (!pending?.el) return;
    const { el, top } = pending;
    tabScrollRestoreRef.current = null;
    const apply = () => {
      el.scrollTop = top;
    };
    apply();
    requestAnimationFrame(apply);
    requestAnimationFrame(() => requestAnimationFrame(apply));
    const t0 = window.setTimeout(apply, 0);
    const t1 = window.setTimeout(apply, 32);
    const t2 = window.setTimeout(apply, 100);
    return () => {
      window.clearTimeout(t0);
      window.clearTimeout(t1);
      window.clearTimeout(t2);
    };
  }, [activeTab]);

  const showToast = (message, type = "success") => {
    setToastPopup({ show: true, message, type });
  };
  const closeToast = () => setToastPopup((p) => ({ ...p, show: false }));

  // Generate years for dropdowns
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 50 }, (_, i) => currentYear - i);

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state?.openGoalsPopup) {
      setShowGoalsPopup(true);
      navigate(location.pathname, { replace: true, state: { ...location.state, openGoalsPopup: false } });
    }
  }, [location.state?.openGoalsPopup]);

  // Reset profile image state when USERID changes (e.g., on logout/login)
  useEffect(() => {
    // Reset all profile image related state
    setProfileImage(null);
    setProfileImageUrl("");
    setProfileImagePreview("");
  }, [USERID]);

  useEffect(() => {
    if (USERID) {
      profileDetails();
      if (OrgID) fetchBannerData();
    } else {
      // Clear profile image if no USERID
      setProfileImageUrl("");
      setProfileImagePreview("");
    }
  }, [USERID, OrgID]);

  useEffect(() => {
    if (activeTab === "Skills" && USERID && OrgID) {
      fetchSkillsList();
    }
  }, [activeTab, USERID, OrgID]);

  useEffect(() => {
    if (isEditingExperience && companyInputRef.current && activeTab === "Experience") {
      // Focus on the Company field when edit mode is enabled
      setTimeout(() => {
        companyInputRef.current?.focus();
      }, 100);
    }
  }, [isEditingExperience, activeTab]);

  // Scroll to newly added experience when Add is clicked
  useEffect(() => {
    if (activeTab === "Experience" && workExperience.length === prevWorkExpLengthRef.current + 1) {
      prevWorkExpLengthRef.current = workExperience.length;
      setTimeout(() => {
        lastExperienceRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    } else {
      prevWorkExpLengthRef.current = workExperience.length;
    }
  }, [workExperience, activeTab]);

  // Scroll to newly added skill when Add is clicked
  useEffect(() => {
    if (activeTab === "Skills") {
      const shouldScroll =
        pendingSkillAddScrollRef.current && skills.length === prevSkillsLengthRef.current + 1;

      if (shouldScroll) {
        pendingSkillAddScrollRef.current = false;
        prevSkillsLengthRef.current = skills.length;
        setTimeout(() => {
          lastSkillRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      } else {
        // Clear any pending scroll request if the expected "add" didn't happen.
        pendingSkillAddScrollRef.current = false;
        prevSkillsLengthRef.current = skills.length;
      }
    } else {
      prevSkillsLengthRef.current = skills.length;
    }
  }, [skills, activeTab]);

  useEffect(() => {
    if (activeTab === "Portfolio" && USERID) {
      console.log("Fetching profile videos for Portfolio tab");
      fetchProfileVideos();
    }
  }, [activeTab, USERID]);

  async function fetchBannerData() {
    if (!USERID || !OrgID) return;
    const key = JSON.parse(localStorage.getItem("access-token"));
    try {
      const response = await fetch(`${baseurl}/banner/data/retrive`, {
        method: "POST",
        body: JSON.stringify({ user_id: USERID, org_id: OrgID }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${key}`,
        },
      });
      const data = await response.json();
      if (data.status === true && data.data) {
        const completionPayload = {};
        if (data.data.profile_completion !== undefined) {
          setProfileCompleted(data.data.profile_completion);
          completionPayload.profile_completion = data.data.profile_completion;
        }
        if (data.data.goals_completion !== undefined) {
          setGoalCompleted(data.data.goals_completion);
          completionPayload.goals_completion = data.data.goals_completion;
        }
        if (Object.keys(completionPayload).length > 0) {
          localStorage.setItem("completionSyncData", JSON.stringify(completionPayload));
          window.dispatchEvent(new CustomEvent("duno-completion-updated", { detail: completionPayload }));
        }
      }
    } catch (error) {
      console.error("Error fetching banner data:", error);
    }
  }

  async function profileDetails() {
    const body = {
      user_id: USERID,
      org_id: OrgID,
    };

    // First, try to load candidate profile data
    try {
      const candidateProfileResponse = await fetch(`${baseurl}/candidate/profile/get`, {
        method: "POST",
        body: JSON.stringify({ user_id: USERID }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const candidateProfileData = await candidateProfileResponse.json();
      
      if (candidateProfileData.status === true && candidateProfileData.data && candidateProfileData.data.length > 0) {
        const profile = candidateProfileData.data[0];
        
        // Populate personal info
        if (profile.personal_info) {
          setPersonalInfo({
            fullName: profile.personal_info.full_name || "",
            email: profile.personal_info.email || "",
            phone: profile.personal_info.phone || "",
            phoneCountryCode: profile.personal_info.phone_country_code || "+91",
            city: profile.personal_info.city || "",
            country: profile.personal_info.country || "",
          });
        }
        
        // Populate profile image
        if (profile.profile_image) {
          setProfileImageUrl(profile.profile_image);
        }
        
        // Populate resume
        if (profile.resume) {
          setResumeFileName(profile.resume.file_name || "");
          setResumeUploadDate(profile.resume.upload_date || "");
          setResumeUrl(profile.resume.file_url || "");
        }
        
        // Populate summary
        setSummary(profile.summary || "");
        
        // Populate education
        if (profile.education && Array.isArray(profile.education)) {
          const educationWithIds = profile.education.map((edu, index) => ({
            id: Date.now() + index,
            school: edu.school || "",
            degree: edu.degree || "",
            startYear: edu.start_year || "",
            endYear: edu.end_year || "",
            major: edu.major || "",
            gpa: edu.gpa || "",
          }));
          setEducation(educationWithIds);
        }
        
        // Populate work experience
        if (profile.work_experience && Array.isArray(profile.work_experience)) {
          const workExpWithIds = profile.work_experience.map((exp, index) => ({
            id: Date.now() + index + 1000,
            company: exp.company || "",
            role: exp.role || "",
            startYear: exp.start_year || "",
            endYear: exp.end_year || "",
            city: exp.city || "",
            country: exp.country || "",
            description: exp.description || "",
          }));
          setWorkExperience(workExpWithIds);
        }
        
        // Populate projects
        if (profile.projects && Array.isArray(profile.projects)) {
          const projectsWithIds = profile.projects.map((proj, index) => ({
            id: Date.now() + index + 2000,
            projectName: proj.project_name || "",
            startYear: proj.start_year || "",
            endYear: proj.end_year || "",
            description: proj.description || "",
          }));
          setProjects(projectsWithIds);
        }
        
        // Populate links
        if (profile.links && Array.isArray(profile.links) && profile.links.length > 0) {
          const firstLink = profile.links[0];
          setLinks({
            name: firstLink.name || firstLink.type || firstLink.title || "",
            url: firstLink.url || "",
          });
        } else {
          setLinks({
            name: "",
            url: "",
          });
        }
        
        // Populate skills - normalize to { id, title, description }
        if (profile.skills && Array.isArray(profile.skills)) {
          setSkills(profile.skills.map((s, i) => {
            if (typeof s === "string") {
              return { id: Date.now() + i + 3000, title: s, description: "" };
            }
            return {
              id: s.id || Date.now() + i + 3000,
              title: s.title || s.name || s.skill || "",
              description: s.description || "",
            };
          }));
        }
        
        // Fetch profile image URL from user profile endpoint
        try {
          const userProfileResponse = await fetch(`${baseurl}/user/profile`, {
            method: "POST",
            body: JSON.stringify({ user_id: USERID, org_id: OrgID }),
            headers: {
              "Content-Type": "application/json",
            },
          });
          const userProfileData = await userProfileResponse.json();
          if (userProfileData.status === true && userProfileData.data) {
            // Only set image URL if it exists and is not empty
            if (userProfileData.data.profile_image && userProfileData.data.profile_image.trim() !== "") {
              setProfileImageUrl(userProfileData.data.profile_image);
            } else {
              // Clear image URL if no image found for this user
              setProfileImageUrl("");
            }
          } else {
            // Clear image URL if profile fetch failed
            setProfileImageUrl("");
          }
        } catch (error) {
          console.error("Error fetching profile image:", error);
          // Clear image URL on error
          setProfileImageUrl("");
        }
        
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        return;
      }
    } catch (error) {
      console.error("Error loading candidate profile:", error);
    }

    // Fallback to original user profile endpoint
    await fetch(`${baseurl}/user/profile`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === true) {
          // Populate form with existing data
          setPersonalInfo({
            fullName: data.data.FirstName + " " + (data.data.LastName || ""),
            email: data.data.Email || "",
            phone: "",
            phoneCountryCode: "+91",
            city: "",
            country: data.data.country || "",
          });
          // Set profile image URL if available, otherwise clear it
          if (data.data.profile_image && data.data.profile_image.trim() !== "") {
            setProfileImageUrl(data.data.profile_image);
          } else {
            setProfileImageUrl("");
          }
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error loading profile:", error);
        setLoading(false);
      });
  }

  async function fetchSkillsList() {
    try {
      const response = await fetch(`${baseurl}/candidate/skills/list`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: USERID,
          org_id: OrgID,
        }),
      });

      const data = await response.json();
      
      if (data.status === true && data.data) {
        const raw = Array.isArray(data.data) ? data.data : [];
        const normalized = raw.map((s, i) => {
          if (typeof s === "string") {
            return { id: Date.now() + i + 4000, title: s, description: "" };
          }
          return {
            id: s.id || Date.now() + i + 4000,
            title: s.title || s.name || s.skill || "",
            description: s.description || "",
          };
        });
        setSkills(normalized);
      } else {
        console.error("Failed to fetch skills:", data.description || "Unknown error");
        setSkills([]);
      }
    } catch (error) {
      console.error("Error fetching skills list:", error);
      setSkills([]);
    }
  }

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setResumeFile(file);
      setResumeFileName(file.name);
      setResumeUploadDate(new Date().toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" }));
      setResumeUrl("");
    }
  };

  const handleReplaceResume = () => {
    fileInputRef.current?.click();
  };

  const handleRemoveResume = () => {
    setResumeFile(null);
    setResumeFileName("");
    setResumeUploadDate("");
    setResumeUrl("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.match(/^image\/(jpeg|jpg|png)$/)) {
        showToast("Please upload a valid image file (JPEG or PNG)", "error");
        return;
      }
      
      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        showToast("Image size should be less than 5MB", "error");
        return;
      }

      setProfileImage(file);
      
      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        const previewDataUrl = reader.result;
        setProfileImagePreview(previewDataUrl);
        const imagePayload = { profile_image: previewDataUrl, ts: Date.now(), user_id: String(USERID) };
        localStorage.setItem("profileImageSyncData", JSON.stringify(imagePayload));
        window.dispatchEvent(new CustomEvent("duno-profile-image-updated", { detail: imagePayload }));
      };
      reader.readAsDataURL(file);
    }
  };

  const uploadProfileImage = async () => {
    if (!profileImage) return null;
    
    const formData = new FormData();
    formData.append("image", profileImage);
    formData.append("user_id", USERID);

    try {
      const response = await fetch(`${baseurl}/candidate/profile/image/upload`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      
      if (data.status === true) {
        // Get the image URL from the response
        const imageUrl = data.data && data.data.length > 0 && data.data[0].image_url 
          ? data.data[0].image_url 
          : null;
        
        if (imageUrl) {
          // Store the actual image URL so it persists after refresh
          setProfileImageUrl(imageUrl);
          const imagePayload = { profile_image: imageUrl, ts: Date.now(), user_id: String(USERID) };
          localStorage.setItem("profileImageSyncData", JSON.stringify(imagePayload));
          window.dispatchEvent(new CustomEvent("duno-profile-image-updated", { detail: imagePayload }));
          // Keep the preview for immediate display, it will be cleared on page refresh
        }
        
        return imageUrl || profileImagePreview;
      } else {
        throw new Error(data.description || "Image upload failed");
      }
    } catch (error) {
      console.error("Error uploading profile image:", error);
      throw error;
    }
  };

  const sanitizeAlphaSpaceInline = (value) =>
    (value ?? "")
      .toString()
      .replace(/[^A-Za-z\s]/g, "")
      .replace(/\s{2,}/g, " ")
      .replace(/^\s+/g, "");

  const sanitizeSchoolInline = (value) =>
    (value ?? "")
      .toString()
      .replace(/[^A-Za-z0-9\s.&\-'"’]/g, "")
      .replace(/\s{2,}/g, " ")
      .replace(/^\s+/g, "");

  const isValidSchoolName = (value) => {
    const v = String(value ?? "").trim();
    if (!v) return false;
    // Block trivial one-character values like "a".
    const alnumCount = (v.match(/[A-Za-z0-9]/g) || []).length;
    if (alnumCount < 2) return false;
    // Allow words/numbers separated by a single space or punctuation segment.
    // Examples: "St. Joseph's School", "ABC School No.2", "PSG-Tech".
    return /^[A-Za-z0-9]+(?:[ .&\-'"’][A-Za-z0-9]+)*$/.test(v);
  };

  const sanitizeDegreeInline = (value) =>
    (value ?? "")
      .toString()
      .replace(/[^A-Za-z0-9\s.\-]/g, "")
      .replace(/\s{2,}/g, " ")
      .replace(/^\s+/g, "");

  const sanitizeMajorInline = (value) =>
    (value ?? "")
      .toString()
      .replace(/[^A-Za-z0-9\s.&()\-–]/g, "")
      .replace(/\s{2,}/g, " ")
      .replace(/^\s+/g, "");

  const isValidDegreeName = (value) => {
    const v = String(value ?? "").trim();
    if (!v) return false;
    // Block trivial one-character values like "a".
    const alnumCount = (v.match(/[A-Za-z0-9]/g) || []).length;
    if (alnumCount < 2) return false;
    // Allow degree tokens separated by single space/dot/hyphen only.
    // Examples: "B.Tech", "B.Sc IT", "MCA-2 Year".
    return /^[A-Za-z0-9]+(?:[ .-][A-Za-z0-9]+)*$/.test(v);
  };

  const isValidMajorName = (value) => {
    const v = String(value ?? "").trim();
    if (!v) return false;
    // Block trivial one-character values like "a".
    const alnumCount = (v.match(/[A-Za-z0-9]/g) || []).length;
    if (alnumCount < 2) return false;
    // Allow major names with alphanumeric words and limited formatting chars.
    // Examples: "AI & ML", "Computer Science 2.0", "Civil Engineering (Smart Infrastructure)".
    return /^[A-Za-z0-9]+(?:[ .&()\-–][A-Za-z0-9]+)*$/.test(v);
  };

  const sanitizeProjectNameInline = (value) =>
    (value ?? "")
      .toString()
      .replace(/[^A-Za-z0-9\s._\-]/g, "")
      .replace(/\s{2,}/g, " ")
      .replace(/^\s+/g, "");

  const isValidProjectName = (value) => {
    const v = String(value ?? "").trim();
    if (!v) return false;
    // Block trivial values like "a" or symbol-led short values like "-o".
    const alnumCount = (v.match(/[A-Za-z0-9]/g) || []).length;
    if (alnumCount < 2) return false;
    // Allow project names like "E-commerce App v2.0", "CRM_v1.2", "API-Gateway_2".
    // Must start with alphanumeric; separators allowed only between tokens.
    return /^[A-Za-z0-9]+(?:[ ._-][A-Za-z0-9]+)*$/.test(v);
  };

  const sanitizeProjectDescriptionInline = (value) =>
    (value ?? "")
      .toString()
      // Allow descriptive text with numbers and common punctuation/special chars.
      .replace(/[^A-Za-z0-9\s.,\-()&:/%+#'!"?]/g, "")
      .replace(/\s{2,}/g, " ")
      .replace(/^\s+/g, "");

  const isValidProjectDescription = (value) => {
    const v = String(value ?? "").trim();
    if (v.length < 5) return false;
    if (!/[A-Za-z]/.test(v)) return false;
    if (!/^[A-Za-z0-9\s.,\-()&:/%+#'!"?]+$/.test(v)) return false;
    // Reject noisy punctuation-heavy strings like "!!!!!!!!" or "#)____".
    if (/[^A-Za-z0-9\s]{4,}/.test(v)) return false;
    const symbolCount = (v.match(/[^A-Za-z0-9\s]/g) || []).length;
    const alphaNumCount = (v.match(/[A-Za-z0-9]/g) || []).length;
    if (symbolCount > alphaNumCount) return false;
    return true;
  };

  const sanitizeSkillTitleInline = (value) =>
    (value ?? "")
      .toString()
      .replace(/[^A-Za-z0-9\s.+#]/g, "")
      .replace(/\s{2,}/g, " ")
      .replace(/^\s+/g, "");

  const isValidSkillTitle = (value) => {
    const v = String(value ?? "").trim();
    if (!v) return false;
    // Support titles like React.js, Python 3, C++, C#, Node.js.
    // Each token must start with alphanumeric; +/#/. are allowed within tokens.
    if (!/^[A-Za-z0-9][A-Za-z0-9+#.]*(?:\s+[A-Za-z0-9][A-Za-z0-9+#.]*)*$/.test(v)) return false;
    // Must include at least one letter so symbols-only values never pass.
    if (!/[A-Za-z]/.test(v)) return false;
    return true;
  };

  const sanitizeSkillDescriptionInline = (value) =>
    (value ?? "")
      .toString()
      .replace(/[^A-Za-z0-9\s.,_\-()&:/%+#'!"?]/g, "")
      .replace(/\s{2,}/g, " ")
      .replace(/^\s+/g, "");

  const isValidSkillDescription = (value) => {
    const v = String(value ?? "").trim();
    if (v.length < 3) return false;
    // Keep free-text support but reject symbol-only/noise-only input.
    if (!/^[A-Za-z0-9\s.,_\-()&:/%+#'!"?]+$/.test(v)) return false;
    if (!/[A-Za-z]/.test(v)) return false;
    const symbolCount = (v.match(/[^A-Za-z0-9\s]/g) || []).length;
    const alphaNumCount = (v.match(/[A-Za-z0-9]/g) || []).length;
    if (symbolCount > alphaNumCount) return false;
    return true;
  };

  const sanitizePortfolioTitleInline = (value) =>
    (value ?? "")
      .toString()
      .replace(/[^A-Za-z0-9\s._\-]/g, "")
      .replace(/\s{2,}/g, " ")
      .replace(/^\s+/g, "");

  const isValidPortfolioTitle = (value) => {
    const v = String(value ?? "").trim();
    if (!v) return false;
    const alnumCount = (v.match(/[A-Za-z0-9]/g) || []).length;
    if (alnumCount < 2) return false;
    // Allows formats like "Portfolio v2.0" and "My-Work_2024".
    if (!/^[A-Za-z0-9]+(?:[ ._-][A-Za-z0-9]+)*$/.test(v)) return false;
    return true;
  };

  const sanitizePortfolioDescriptionInline = (value) =>
    (value ?? "")
      .toString()
      .replace(/[^A-Za-z0-9\s.,_\-()&:/%+#'!"?@[\]{};*=|~`$^]/g, "")
      .replace(/\s{2,}/g, " ")
      .replace(/^\s+/g, "");

  const isValidPortfolioDescription = (value) => {
    const v = String(value ?? "").trim();
    if (!v) return true; // Optional field
    if (v.length < 3) return false;
    if (!/^[A-Za-z0-9\s.,_\-()&:/%+#'!"?@[\]{};*=|~`$^]+$/.test(v)) return false;
    // Ensure content is meaningful (not only separators/spaces).
    if (!/[A-Za-z0-9]/.test(v)) return false;
    if (/[^A-Za-z0-9\s]{4,}/.test(v)) return false;
    return true;
  };

  const sanitizeRoleInline = (value) =>
    (value ?? "")
      .toString()
      .replace(/[^A-Za-z0-9\s\-+.#]/g, "")
      .replace(/\s{2,}/g, " ")
      .replace(/^\s+/g, "");

  const isValidRoleName = (value) => {
    const v = String(value ?? "").trim();
    if (!v) return false;
    // Supports formats like "SDE-1", "QA Engineer II", ".Net dev", "C++ dev", "C# Engineer".
    // Token may start with optional dot (for ".Net"), and can include +/#/. inside.
    if (!/^(?:\.?[A-Za-z0-9][A-Za-z0-9+#.]*)(?:[ -](?:\.?[A-Za-z0-9][A-Za-z0-9+#.]*))*$/.test(v)) return false;
    if (!/[A-Za-z]/.test(v)) return false;
    const alnumCount = (v.match(/[A-Za-z0-9]/g) || []).length;
    if (alnumCount < 2) return false;
    // Prevent weak pattern like single letter followed by digits (e.g. "a22222").
    if (/^[A-Za-z]\d+$/.test(v)) return false;
    return true;
  };

  const handleEducationChange = (id, field, value) => {
    const nextValue =
      field === "school"
        ? sanitizeSchoolInline(value)
        : field === "degree"
        ? sanitizeDegreeInline(value)
        : field === "major"
        ? sanitizeMajorInline(value)
        : value;
    setEducation(
      education.map((edu) =>
        edu.id === id ? { ...edu, [field]: nextValue } : edu
      )
    );
  };

  const addEducation = () => {
    setEducation([
      ...education,
      {
        id: Date.now(),
        school: "",
        degree: "",
        startYear: "",
        endYear: "",
        major: "",
        gpa: "",
      },
    ]);
  };

  const removeEducation = (id) => {
    setEducation(education.filter((edu) => edu.id !== id));
  };

  const handleWorkExperienceChange = (id, field, value) => {
    const nextValue =
      field === "company" ||
      field === "city" ||
      field === "description"
        ? sanitizeAlphaSpaceInline(value)
        : field === "role"
        ? sanitizeRoleInline(value)
        : value;
    setWorkExperience(
      workExperience.map((exp) =>
        exp.id === id ? { ...exp, [field]: nextValue } : exp
      )
    );
  };

  const addWorkExperience = () => {
    setWorkExperience([
      ...workExperience,
      {
        id: Date.now(),
        company: "",
        role: "",
        startYear: "",
        endYear: "",
        city: "",
        country: "",
        description: "",
      },
    ]);
    // Enable editing when adding new experience
    setIsEditingExperience(true);
  };

  const removeWorkExperience = async (id) => {
    const previousExperience = workExperience;
    const updatedExperience = workExperience.filter((exp) => exp.id !== id);
    setWorkExperience(updatedExperience);

    try {
      const response = await fetch(`${baseurl}/candidate/profile/save`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: USERID,
          org_id: OrgID,
          my_experience: updatedExperience.map(exp => ({
            company: exp.company,
            role: exp.role,
            start_year: exp.startYear,
            end_year: exp.endYear,
            city: exp.city,
            country: exp.country,
            description: exp.description,
          })),
        }),
      });

      const data = await response.json();
      if (data.status !== true) {
        setWorkExperience(previousExperience);
        showToast("Failed to remove experience: " + (data.description || "Unknown error"), "error");
        return;
      }
      fetchBannerData();
    } catch (error) {
      setWorkExperience(previousExperience);
      showToast("An error occurred while removing experience", "error");
    }
  };

  const handleProjectChange = (id, field, value) => {
    const nextValue =
      field === "projectName"
        ? sanitizeProjectNameInline(value)
        : field === "description"
        ? sanitizeProjectDescriptionInline(value)
        : value;
    setProjects(
      projects.map((proj) =>
        proj.id === id ? { ...proj, [field]: nextValue } : proj
      )
    );
  };

  const addProject = () => {
    setProjects([
      ...projects,
      {
        id: Date.now(),
        projectName: "",
        startYear: "",
        endYear: "",
        description: "",
      },
    ]);
  };

  const removeProject = (id) => {
    setProjects(projects.filter((proj) => proj.id !== id));
  };

  const handleSkillChange = (id, field, value) => {
    const nextValue =
      field === "title"
        ? sanitizeSkillTitleInline(value)
        : field === "description"
        ? sanitizeSkillDescriptionInline(value)
        : value;
    setSkills(
      skills.map((s) => (s.id === id ? { ...s, [field]: nextValue } : s))
    );
  };

  const addSkillEntry = () => {
    pendingSkillAddScrollRef.current = true;
    const newId = Date.now();
    setSkills([
      ...skills,
      { id: newId, title: "", description: "" },
    ]);
    setEditingSkillId(newId);
  };

  const removeSkillEntry = async (id) => {
    const previousSkills = skills;
    const updatedSkills = skills.filter((s) => s.id !== id);
    setSkills(updatedSkills);
    // If an add-scroll was pending, don't keep it alive after other skill mutations.
    pendingSkillAddScrollRef.current = false;
    if (editingSkillId === id) setEditingSkillId(null);

    try {
      // Save only valid non-empty skill titles while removing.
      // This prevents delete failures when malformed legacy entries exist.
      const skillsPayload = updatedSkills
        .map((s) => sanitizeSkillTitleInline(String(s.title ?? "")).trim())
        .filter((title) => isValidSkillTitle(title));

      const response = await fetch(`${baseurl}/candidate/profile/save`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: USERID,
          org_id: OrgID,
          my_skill: skillsPayload,
        }),
      });

      const data = await response.json();
      if (data.status !== true) {
        setSkills(previousSkills);
        showToast("Failed to remove skill: " + (data.description || "Unknown error"), "error");
        return;
      }
      fetchBannerData();
    } catch (error) {
      setSkills(previousSkills);
      showToast("An error occurred while removing the skill", "error");
    }
  };

  const uploadResumeToS3 = async () => {
    if (!resumeFile) return null;
    const formData = new FormData();
    formData.append("resume", resumeFile);
    formData.append("user_id", USERID);
    if (OrgID) {
      formData.append("org_id", OrgID);
    }

    const res = await fetch(`${baseurl}/candidate/resume/upload`, {
      method: "POST",
      body: formData,
    });
    const data = await res.json();
    if (data.status !== true || !data.data || data.data.length === 0) {
      throw new Error(data.description || "Resume upload failed");
    }
    const payload = data.data[0];
    setResumeUrl(payload.resume_url || "");
    setResumeFileName(payload.resume_file_name || resumeFileName);
    setResumeUploadDate(payload.upload_date || resumeUploadDate);
    return payload;
  };

  const sanitizeFullName = (value) =>
    value
      .replace(/[^A-Za-z\s]/g, "")
      .replace(/\s{2,}/g, " ")
      .replace(/^\s+/g, "");
  const isValidFullName = (value) =>
    /^[A-Za-z]+(?:\s+[A-Za-z]+)*$/.test((value ?? "").trim());
  const isValidEmail = (value) => {
    const v = (value ?? "").trim();
    if (!v) return true; // allow empty if backend allows
    // Practical email validation: blocks obvious invalid strings like "no email"
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  };
  const sanitizePhone10 = (value) =>
    (value ?? "").toString().replace(/\D/g, "").slice(0, 10);
  const sanitizeCity = (value) =>
    (value ?? "")
      .toString()
      .replace(/[^A-Za-z\s]/g, "")
      .replace(/\s{2,}/g, " ")
      .replace(/^\s+/g, "");
  const sanitizeLinkLabel = (value) =>
    (value ?? "")
      .toString()
      // Strict: only letters and spaces (no numbers, no special characters)
      .replace(/[^A-Za-z\s]/g, "")
      .replace(/\s{2,}/g, " ")
      .replace(/^\s+/g, "");
  const sanitizeUrlInput = (value) =>
    (value ?? "")
      .toString()
      // Keep URL usable but block unsafe/surprising chars for an input field
      .replace(/\s+/g, "")
      .replace(/[<>"'`]/g, "");
  const isValidCity = (value) =>
    /^[A-Za-z]+(?:\s+[A-Za-z]+)*$/.test((value ?? "").trim());
  const isValidHttpUrl = (value) => {
    const v = (value ?? "").trim();
    if (!v) return true;
    try {
      const u = new URL(v);
      if (!(u.protocol === "http:" || u.protocol === "https:")) return false;
      if (u.username || u.password) return false;

      const host = (u.hostname || "").toLowerCase();
      if (!host) return false;
      if (host === "localhost") return true;
      if (!host.includes(".")) return false;
      if (!/^[a-z0-9.-]+$/.test(host)) return false;

      const parts = host.split(".");
      if (parts.some((p) => !p)) return false;
      if (parts.some((p) => p.startsWith("-") || p.endsWith("-") || p.length > 63)) return false;
      if ((parts[parts.length - 1] || "").length < 2) return false;

      return true;
    } catch {
      return false;
    }
  };
  const isValidYear = (value) => {
    const v = String(value ?? "").trim();
    if (!v) return false;
    if (!/^\d{4}$/.test(v)) return false;
    const year = Number(v);
    return year >= 1900 && year <= 2100;
  };
  const isValidGpa = (value) => {
    const v = String(value ?? "").trim();
    if (!v) return false;
    if (!/^(10(\.0{1,2})?|[0-9](\.\d{1,2})?)$/.test(v)) return false;
    const n = Number(v);
    return Number.isFinite(n) && n >= 0 && n <= 10;
  };
  const sanitizeGpaInput = (value) => {
    let v = String(value ?? "").replace(/[^\d.]/g, "");
    const firstDot = v.indexOf(".");
    if (firstDot !== -1) {
      v = v.slice(0, firstDot + 1) + v.slice(firstDot + 1).replace(/\./g, "");
      const parts = v.split(".");
      const intPart = parts[0];
      const decPart = (parts[1] || "").slice(0, 2);
      v = decPart.length > 0 ? `${intPart}.${decPart}` : `${intPart}${v.endsWith(".") ? "." : ""}`;
    }
    if (v && v !== ".") {
      const n = Number(v);
      if (Number.isFinite(n) && n > 10) return "10";
    }
    return v;
  };
  const resolveImageSrc = (urlValue) => {
    const normalizedUrl = String(urlValue || "").trim();
    if (!normalizedUrl) return "";
    if (normalizedUrl.startsWith("data:")) return normalizedUrl;
    return `${normalizedUrl}${normalizedUrl.includes("?") ? "&" : "?"}uid=${USERID || ""}`;
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      let resumePayload = null;
      if (resumeFile) {
        resumePayload = await uploadResumeToS3();
      }

      // Upload profile image if selected and get the URL
      let profileImageUrlValue = profileImageUrl;
      if (profileImage) {
        try {
          profileImageUrlValue = await uploadProfileImage();
        } catch (error) {
          showToast("Failed to upload profile image: " + error.message, "error");
          setLoading(false);
          return;
        }
      }

      const cleanedFullName = sanitizeFullName(personalInfo.fullName || "").trim();
      if (!cleanedFullName) {
        showToast("Please provide the full name.", "error");
        setLoading(false);
        return;
      }
      if (!isValidFullName(cleanedFullName)) {
        showToast(
          "Full Name should contain only alphabetic characters (A-Z, a-z) and spaces.",
          "error"
        );
        setLoading(false);
        return;
      }

      const cleanedEmail = (personalInfo.email || "").trim();
      if (!isValidEmail(cleanedEmail)) {
        showToast("Please enter a valid email address.", "error");
        setLoading(false);
        return;
      }

      const cleanedPhone = sanitizePhone10(personalInfo.phone || "");
      if (cleanedPhone && cleanedPhone.length !== 10) {
        showToast("Phone number must be exactly 10 digits.", "error");
        setLoading(false);
        return;
      }

      const cleanedCity = sanitizeCity(personalInfo.city || "").trim();
      if (!cleanedCity) {
        showToast("Please provide the city name.", "error");
        setLoading(false);
        return;
      }
      if (!isValidCity(cleanedCity)) {
        showToast("City should contain only alphabetic characters.", "error");
        setLoading(false);
        return;
      }

      const cleanedCountry = (personalInfo.country || "").trim();
      if (!cleanedCountry) {
        showToast("Please select a country.", "error");
        setLoading(false);
        return;
      }

      const cleanedLinkUrl = (links?.url || "").trim();
      if (!isValidHttpUrl(cleanedLinkUrl)) {
        showToast("Please enter a valid URL (starting with http:// or https://).", "error");
        setLoading(false);
        return;
      }

      // Education validation (all fields mandatory per requirement)
      for (let i = 0; i < education.length; i++) {
        const edu = education[i] || {};
        const school = String(edu.school ?? "").trim();
        const degree = String(edu.degree ?? "").trim();
        const major = String(edu.major ?? "").trim();
        const startYear = String(edu.startYear ?? "").trim();
        const endYear = String(edu.endYear ?? "").trim();
        const gpa = String(edu.gpa ?? "").trim();

        if (!school) {
          showToast("Please fill the education fields.", "error");
          setLoading(false);
          return;
        }
        if (!isValidSchoolName(school)) {
          showToast(
            "School name can contain letters, numbers, spaces, and single separators like . - & '.",
            "error"
          );
          setLoading(false);
          return;
        }
        if (!degree) {
          showToast("Please fill the education fields.", "error");
          setLoading(false);
          return;
        }
        if (!isValidDegreeName(degree)) {
          showToast(
            "Degree name can contain letters, numbers, spaces, and single separators like . or -.",
            "error"
          );
          setLoading(false);
          return;
        }
        if (!isValidYear(startYear)) {
          showToast("Please fill the education fields.", "error");
          setLoading(false);
          return;
        }
        if (!isValidYear(endYear)) {
          showToast("Please fill the education fields.", "error");
          setLoading(false);
          return;
        }
        if (Number(startYear) > Number(endYear)) {
          showToast("Start year cannot be greater than end year.", "error");
          setLoading(false);
          return;
        }
        if (!major) {
          showToast("Please fill the education fields.", "error");
          setLoading(false);
          return;
        }
        if (!isValidMajorName(major)) {
          showToast(
            "Major can contain letters, numbers, spaces, and limited separators like &, ., -, –, and parentheses.",
            "error"
          );
          setLoading(false);
          return;
        }
        if (!isValidGpa(gpa)) {
          showToast("Please fill the education fields.", "error");
          setLoading(false);
          return;
        }
      }

      // Work experience validation (all experience fields are required per entry)
      for (let i = 0; i < workExperience.length; i++) {
        const exp = workExperience[i] || {};
        const company = String(exp.company ?? "").trim();
        const role = String(exp.role ?? "").trim();
        const startYear = String(exp.startYear ?? "").trim();
        const endYear = String(exp.endYear ?? "").trim();
        const city = String(exp.city ?? "").trim();
        const country = String(exp.country ?? "").trim();
        const description = String(exp.description ?? "").trim();

        if (!company || !role || !startYear || !endYear || !city || !country || !description) {
          showToast("Please fill the experience fields.", "error");
          setLoading(false);
          return;
        }
        if (!isValidRoleName(role)) {
          showToast(
            "Role can contain letters, numbers, spaces, and symbols like -, ., +, # (e.g., SDE-1, .Net dev, C++ dev).",
            "error"
          );
          setLoading(false);
          return;
        }

        const endYearIsPresent = endYear === "Present";
        if (!isValidYear(startYear) || (!endYearIsPresent && !isValidYear(endYear))) {
          showToast("Please fill the experience fields.", "error");
          setLoading(false);
          return;
        }

        if (!endYearIsPresent && Number(startYear) > Number(endYear)) {
          showToast("Start year cannot be greater than end year.", "error");
          setLoading(false);
          return;
        }
      }

      // Project validation (all project fields are required per entry)
      for (let i = 0; i < projects.length; i++) {
        const proj = projects[i] || {};
        const projectName = sanitizeProjectNameInline(String(proj.projectName ?? "")).trim();
        const startYear = String(proj.startYear ?? "").trim();
        const endYear = String(proj.endYear ?? "").trim();
        const description = sanitizeProjectDescriptionInline(String(proj.description ?? "")).trim();

        if (!projectName || !startYear || !endYear || !description) {
          showToast("Please fill the project fields.", "error");
          setLoading(false);
          return;
        }
        if (!isValidProjectName(projectName)) {
          showToast(
            "Project name can contain letters, numbers, spaces, and single separators like . - or _.",
            "error"
          );
          setLoading(false);
          return;
        }
        if (!isValidYear(startYear) || !isValidYear(endYear)) {
          showToast("Please fill the project fields.", "error");
          setLoading(false);
          return;
        }
        if (Number(startYear) > Number(endYear)) {
          showToast("Project start year cannot be greater than end year.", "error");
          setLoading(false);
          return;
        }
        if (!isValidProjectDescription(description)) {
          showToast(
            "Please enter a valid project description with meaningful text. Letters, numbers, and common punctuation are allowed.",
            "error"
          );
          setLoading(false);
          return;
        }
      }

      const profileData = {
        user_id: USERID,
        org_id: OrgID,
        personal_info: {
          full_name: cleanedFullName,
          email: cleanedEmail,
          phone: cleanedPhone,
          phone_country_code: personalInfo.phoneCountryCode,
          city: cleanedCity,
          country: cleanedCountry,
        },
        profile_image: profileImageUrlValue || "",
        resume: {
          file_name: resumePayload?.resume_file_name || resumeFileName,
          upload_date: resumePayload?.upload_date || resumeUploadDate,
          file_url: resumePayload?.resume_url || resumeUrl,
        },
        summary: summary,
        education: education.map(edu => ({
          school: edu.school,
          degree: edu.degree,
          start_year: edu.startYear,
          end_year: edu.endYear,
          major: edu.major,
          gpa: edu.gpa,
        })),
        work_experience: workExperience.map(exp => ({
          company: exp.company,
          role: exp.role,
          start_year: exp.startYear,
          end_year: exp.endYear,
          city: exp.city,
          country: exp.country,
          description: exp.description,
        })),
        projects: projects.map(proj => ({
          project_name: proj.projectName,
          start_year: proj.startYear,
          end_year: proj.endYear,
          description: sanitizeProjectDescriptionInline(String(proj.description ?? "")).trim(),
        })),
        links: cleanedLinkUrl ? [{
          name: (links.name || "").trim(),
          url: cleanedLinkUrl,
        }] : [],
        skills: skills.map((s) => ({ title: s.title, description: s.description || "" })),
      };

      const response = await fetch(`${baseurl}/candidate/profile/save`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(profileData),
      });

      const data = await response.json();
      
      if (data.status === true) {
        logActivity({ module: "PROFILE", action: "PROFILE_SAVED", remark: "Profile saved successfully" });
        showToast("Profile saved successfully!");
        setIsSummaryEditing(false);
        fetchBannerData();
        // Clear the profile image file after successful save
        if (profileImage) {
          setProfileImage(null);
          setProfileImagePreview("");
        }
      } else {
        showToast("Failed to save profile: " + (data.description || "Unknown error"), "error");
      }
    } catch (error) {
      console.error("Error saving profile:", error);
      showToast("An error occurred while saving the profile", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    if (window.confirm("Are you sure you want to cancel? All unsaved changes will be lost.")) {
      // Reset form or navigate away
      window.location.reload();
    }
  };

  const handleLinkChange = (field, value) => {
    const nextValue =
      field === "name"
        ? sanitizeLinkLabel(value)
        : field === "url"
          ? sanitizeUrlInput(value)
          : value;
    setLinks((prev) => ({
      ...prev,
      [field]: nextValue,
    }));
  };

  const handleSaveSkills = async () => {
    setLoading(true);
    try {
      for (let i = 0; i < skills.length; i++) {
        const skill = skills[i] || {};
        const title = sanitizeSkillTitleInline(String(skill.title ?? "")).trim();
        const description = sanitizeSkillDescriptionInline(String(skill.description ?? "")).trim();
        if (!title || !description) {
          showToast("Please fill the skill fields.", "error");
          setLoading(false);
          return;
        }
        if (!isValidSkillTitle(title)) {
          showToast(
            "Skill title can contain letters, numbers, spaces, and . + # only. It cannot be symbols-only.",
            "error"
          );
          setLoading(false);
          return;
        }
        if (!isValidSkillDescription(description)) {
          showToast(
            "Skill description should be meaningful text. Numbers and common special characters are allowed.",
            "error"
          );
          setLoading(false);
          return;
        }
      }

      const skillsPayload = skills.map((s) =>
        sanitizeSkillTitleInline(String(s.title ?? "")).trim()
      );
      const response = await fetch(`${baseurl}/candidate/profile/save`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: USERID,
          org_id: OrgID,
          my_skill: skillsPayload,
        }),
      });

      const data = await response.json();
      
      if (data.status === true) {
        logActivity({ module: "PROFILE", action: "SKILLS_SAVED", remark: "Skills saved successfully" });
        showToast("Skills saved successfully!");
        fetchBannerData();
        setEditingSkillId(null);
      } else {
        showToast("Failed to save skills: " + (data.description || "Unknown error"), "error");
      }
    } catch (error) {
      console.error("Error saving skills:", error);
      showToast("An error occurred while saving the skills", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSaveExperience = async () => {
    setLoading(true);
    try {
      // Work experience validation (require all fields for each entry)
      for (let i = 0; i < workExperience.length; i++) {
        const exp = workExperience[i] || {};
        const company = sanitizeAlphaSpaceInline(String(exp.company ?? "")).trim();
        const role = sanitizeRoleInline(String(exp.role ?? "")).trim();
        const startYear = String(exp.startYear ?? "").trim();
        const endYear = String(exp.endYear ?? "").trim();
        const city = sanitizeAlphaSpaceInline(String(exp.city ?? "")).trim();
        const country = String(exp.country ?? "").trim();
        const description = sanitizeAlphaSpaceInline(String(exp.description ?? "")).trim();

        if (!company || !role || !startYear || !endYear || !city || !country || !description) {
          showToast("Please fill the experience fields.", "error");
          setLoading(false);
          return;
        }
        if (!isValidRoleName(role)) {
          showToast(
            "Role can contain letters, numbers, spaces, and symbols like -, ., +, # (e.g., SDE-1, .Net dev, C++ dev).",
            "error"
          );
          setLoading(false);
          return;
        }
        const endYearIsPresent = endYear === "Present";
        if (!isValidYear(startYear) || (!endYearIsPresent && !isValidYear(endYear))) {
          showToast("Please fill the experience fields.", "error");
          setLoading(false);
          return;
        }
        if (!endYearIsPresent && Number(startYear) > Number(endYear)) {
          showToast("Start year cannot be greater than end year.", "error");
          setLoading(false);
          return;
        }
      }

      const response = await fetch(`${baseurl}/candidate/profile/save`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: USERID,
          org_id: OrgID,
          my_experience: workExperience.map(exp => ({
            company: sanitizeAlphaSpaceInline(String(exp.company ?? "")).trim(),
            role: sanitizeRoleInline(String(exp.role ?? "")).trim(),
            start_year: exp.startYear,
            end_year: exp.endYear,
            city: sanitizeAlphaSpaceInline(String(exp.city ?? "")).trim(),
            country: exp.country,
            description: sanitizeAlphaSpaceInline(String(exp.description ?? "")).trim(),
          })),
        }),
      });

      const data = await response.json();
      
      if (data.status === true) {
        logActivity({ module: "PROFILE", action: "EXPERIENCE_SAVED", remark: "Work experience saved successfully" });
        showToast("Work experience saved successfully!");
        fetchBannerData();
        // Disable editing after save
        setIsEditingExperience(false);
      } else {
        showToast("Failed to save work experience: " + (data.description || "Unknown error"), "error");
      }
    } catch (error) {
      console.error("Error saving work experience:", error);
      showToast("An error occurred while saving the work experience", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchProfileVideos = async () => {
    try {
      const response = await fetch(`${baseurl}/profile/content/get`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: USERID,
          org_id: OrgID,
        }),
      });

      const data = await response.json();
      
      if (data.status === true && data.data && data.data.length > 0) {
        setVideos(data.data[0].videos || []);
        setDocuments(data.data[0].documents || []);
      } else {
        setVideos([]);
        setDocuments([]);
      }
    } catch (error) {
      console.error("Error fetching profile videos:", error);
      setVideos([]);
      setDocuments([]);
    }
  };

  const handleVideoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      const allowedExtensions = ['mp4', 'mov', 'avi', 'mkv', 'webm', 'flv', 'wmv', 'm4v'];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      
      if (!allowedExtensions.includes(fileExtension)) {
        showToast(`Please upload a valid video file. Allowed formats: ${allowedExtensions.join(', ')}`, "error");
        return;
      }
      
      // Validate file size (max 100MB)
      if (file.size > 100 * 1024 * 1024) {
        showToast("Video size should be less than 100MB", "error");
        return;
      }

      setSelectedVideo(file);
      setVideoSource("upload");
      setSelectedDocument(null);
      setYoutubeUrl(""); // Clear YouTube URL when video file is selected
      if (documentInputRef.current) documentInputRef.current.value = "";
    }
  };

  const handleDocumentUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt'];
      const fileExtension = file.name.split('.').pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        showToast(`Please upload a valid document. Allowed formats: ${allowedExtensions.join(', ')}`, "error");
        return;
      }

      setSelectedDocument(file);
      setVideoSource("document");
      setSelectedVideo(null);
      setYoutubeUrl("");
      if (videoInputRef.current) videoInputRef.current.value = "";
    }
  };

  const handleRenameDocument = (doc) => {
    setDocNameInput(doc.file_name || doc.title || "Document");
    setDocActionModal({ type: "rename", doc });
  };

  const handleDeleteDocument = (doc) => {
    setDocActionModal({ type: "delete", doc });
  };

  const confirmRenameDocument = async () => {
    const doc = docActionModal?.doc;
    if (!doc) return;
    const trimmedName = String(docNameInput || "").trim();
    if (!trimmedName) {
      showToast("Document name cannot be empty.", "error");
      return;
    }

    try {
      const response = await fetch(`${baseurl}/profile/content/document/update`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: USERID,
          org_id: OrgID,
          object_key: doc.object_key || "",
          file_url: doc.file_url || "",
          file_name: trimmedName,
        }),
      });
      const data = await response.json();
      if (data.status === true) {
        setDocActionModal(null);
        showToast("Document updated successfully!");
        fetchProfileVideos();
      } else {
        showToast("Failed to update document: " + (data.description || "Unknown error"), "error");
      }
    } catch (error) {
      showToast("An error occurred while updating the document", "error");
    }
  };

  const confirmDeleteDocument = async () => {
    const doc = docActionModal?.doc;
    if (!doc) return;

    try {
      const response = await fetch(`${baseurl}/profile/content/document/delete`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: USERID,
          org_id: OrgID,
          object_key: doc.object_key || "",
          file_url: doc.file_url || "",
        }),
      });
      const data = await response.json();
      if (data.status === true) {
        setDocActionModal(null);
        showToast("Document deleted successfully!");
        fetchProfileVideos();
      } else {
        showToast("Failed to delete document: " + (data.description || "Unknown error"), "error");
      }
    } catch (error) {
      showToast("An error occurred while deleting the document", "error");
    }
  };

  const handleEditVideo = (video) => {
    const resolvedTitle = String(
      video.title || video.name || video.file_name || ""
    ).trim();
    const cleanedDescription = String(
      video.description || video.desc || ""
    ).replace(/^\[YOUTUBE\]\s*/i, "").trim();
    setVideoTitleInput(resolvedTitle);
    setVideoDescriptionInput(cleanedDescription);
    setVideoActionModal({ type: "edit", video });
  };

  const handleDeleteVideo = (video) => {
    setVideoActionModal({ type: "delete", video });
  };

  const confirmEditVideo = async () => {
    const video = videoActionModal?.video;
    if (!video) return;
    const cleanedPortfolioTitle = sanitizePortfolioTitleInline(String(videoTitleInput || "")).trim();
    const cleanedPortfolioDesc = sanitizePortfolioDescriptionInline(
      String(videoDescriptionInput || "").replace(/^\[YOUTUBE\]\s*/i, "")
    ).trim();

    if (cleanedPortfolioTitle && !isValidPortfolioTitle(cleanedPortfolioTitle)) {
      showToast(
        "Portfolio title can contain letters, numbers, spaces, and separators like ., -, _.",
        "error"
      );
      return;
    }
    if (!isValidPortfolioDescription(cleanedPortfolioDesc)) {
      showToast(
        "Portfolio description should be meaningful text. Numbers and common special characters are allowed.",
        "error"
      );
      return;
    }

    try {
      const response = await fetch(`${baseurl}/profile/content/video/update`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: USERID,
          org_id: OrgID,
          object_key: video.object_key || "",
          file_url: video.file_url || "",
          title: cleanedPortfolioTitle,
          description: cleanedPortfolioDesc,
        }),
      });
      const data = await response.json();
      if (data.status === true) {
        setVideoActionModal(null);
        showToast("Video updated successfully!");
        fetchProfileVideos();
      } else {
        showToast("Failed to update video: " + (data.description || "Unknown error"), "error");
      }
    } catch (error) {
      showToast("An error occurred while updating the video", "error");
    }
  };

  const confirmDeleteVideo = async () => {
    const video = videoActionModal?.video;
    if (!video) return;

    try {
      const response = await fetch(`${baseurl}/profile/content/video/delete`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: USERID,
          org_id: OrgID,
          object_key: video.object_key || "",
          file_url: video.file_url || "",
        }),
      });
      const data = await response.json();
      if (data.status === true) {
        setVideoActionModal(null);
        showToast("Video deleted successfully!");
        fetchProfileVideos();
      } else {
        showToast("Failed to delete video: " + (data.description || "Unknown error"), "error");
      }
    } catch (error) {
      showToast("An error occurred while deleting the video", "error");
    }
  };

  const extractYouTubeVideoId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  const convertToYouTubeEmbedUrl = (url) => {
    const videoId = extractYouTubeVideoId(url);
    if (videoId) {
      return `https://www.youtube.com/embed/${videoId}`;
    }
    return null;
  };

  const validateYouTubeUrl = (url) => {
    if (!url || !url.trim()) {
      return { valid: false, error: "Please enter a YouTube URL" };
    }
    
    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+/;
    if (!youtubeRegex.test(url)) {
      return { valid: false, error: "Please enter a valid YouTube URL" };
    }
    
    const embedUrl = convertToYouTubeEmbedUrl(url);
    if (!embedUrl) {
      return { valid: false, error: "Could not extract video ID from YouTube URL" };
    }
    
    return { valid: true, embedUrl };
  };

  const uploadVideo = async () => {
    // Determine source based on what's filled
    const isYouTube = youtubeUrl && validateYouTubeUrl(youtubeUrl).valid;
    const isDocument = selectedDocument && !isYouTube;

    if (isDocument) {
      // Handle document upload
      if (!USERID) {
        setUploadError("User ID is missing. Please login again.");
        return;
      }

      setIsUploading(true);
      setUploadProgress(0);
      setUploadError("");

      try {
        const formData = new FormData();
        formData.append("document", selectedDocument);
        formData.append("user_id", USERID);
        if (OrgID) {
          formData.append("org_id", OrgID);
        }
        const cleanedPortfolioTitle = sanitizePortfolioTitleInline(String(videoTitle || "")).trim();
        const cleanedPortfolioDesc = sanitizePortfolioDescriptionInline(String(videoDescription || "")).trim();
        if (cleanedPortfolioTitle && !isValidPortfolioTitle(cleanedPortfolioTitle)) {
          setUploadError(
            "Portfolio title can contain letters, numbers, spaces, and separators like ., -, _."
          );
          setIsUploading(false);
          return;
        }
        if (!isValidPortfolioDescription(cleanedPortfolioDesc)) {
          setUploadError(
            "Portfolio description should be meaningful text. Numbers and common special characters are allowed."
          );
          setIsUploading(false);
          return;
        }
        if (cleanedPortfolioTitle) {
          formData.append("title", cleanedPortfolioTitle);
        }
        if (cleanedPortfolioDesc) {
          formData.append("description", cleanedPortfolioDesc);
        }

        const progressInterval = setInterval(() => {
          setUploadProgress(prev => Math.min(prev + 10, 90));
        }, 200);

        const response = await fetch(`${baseurl}/profile/content/video/upload`, {
          method: "POST",
          body: formData,
        });

        clearInterval(progressInterval);
        setUploadProgress(100);

        const data = await response.json();

        if (data.status === true) {
          setSelectedDocument(null);
          setVideoTitle("");
          setVideoDescription("");
          setUploadProgress(0);
          setShowVideoUploadModal(false);
          if (documentInputRef.current) {
            documentInputRef.current.value = "";
          }
          await fetchProfileVideos();
          showToast("Document uploaded successfully!");
        } else {
          setUploadError(data.description || "Failed to upload document. Please try again.");
        }
      } catch (error) {
        console.error("Error uploading document:", error);
        setUploadError("An error occurred while uploading the document: " + error.message);
      } finally {
        setIsUploading(false);
        setTimeout(() => {
          setUploadProgress(0);
        }, 1000);
      }
      return;
    }

    if (isYouTube) {
      // Handle YouTube URL
      const validation = validateYouTubeUrl(youtubeUrl);

      if (!USERID) {
        setUploadError("User ID is missing. Please login again.");
        return;
      }

      setIsUploading(true);
      setUploadProgress(0);
      setUploadError("");

      try {
        // Validate that we have a valid embed URL
        if (!validation.embedUrl) {
          setUploadError("Invalid YouTube URL. Please check the URL and try again.");
          setIsUploading(false);
          return;
        }

        // For YouTube, we'll save it directly to the backend using the same endpoint
        const formData = new FormData();
        formData.append("user_id", USERID);
        if (OrgID) {
          formData.append("org_id", OrgID);
        }
        const cleanedPortfolioTitle = sanitizePortfolioTitleInline(String(videoTitle || "")).trim();
        const cleanedPortfolioDesc = sanitizePortfolioDescriptionInline(String(videoDescription || "")).trim();
        if (cleanedPortfolioTitle && !isValidPortfolioTitle(cleanedPortfolioTitle)) {
          setUploadError(
            "Portfolio title can contain letters, numbers, spaces, and separators like ., -, _."
          );
          setIsUploading(false);
          return;
        }
        if (!isValidPortfolioDescription(cleanedPortfolioDesc)) {
          setUploadError(
            "Portfolio description should be meaningful text. Numbers and common special characters are allowed."
          );
          setIsUploading(false);
          return;
        }
        if (cleanedPortfolioTitle) {
          formData.append("title", cleanedPortfolioTitle);
        }
        
        const fullDescription = `[YOUTUBE]${cleanedPortfolioDesc ? ' ' + cleanedPortfolioDesc : ''}`;
        formData.append("description", fullDescription);
        
        // Store YouTube embed URL - backend will handle this
        formData.append("youtube_url", validation.embedUrl);
        formData.append("youtube_original_url", youtubeUrl.trim());

        setUploadProgress(50);

        // Use the same upload endpoint - backend will need to handle YouTube URLs
        // For now, we'll save it via a modified approach
        const response = await fetch(`${baseurl}/profile/content/video/upload`, {
          method: "POST",
          body: formData,
        });

        setUploadProgress(100);

        const data = await response.json();
        
        if (data.status === true) {
          // Success - reset form
          setYoutubeUrl("");
          setVideoTitle("");
          setVideoDescription("");
          setVideoSource("upload");
          setUploadProgress(0);
          setShowVideoUploadModal(false);
          // Refresh videos list
          await fetchProfileVideos();
          showToast("YouTube video added successfully!");
        } else {
          setUploadError(data.description || "Failed to add YouTube video. Please try again.");
        }
      } catch (error) {
        console.error("Error adding YouTube video:", error);
        setUploadError("An error occurred while adding YouTube video: " + (error.message || "Please try again."));
      } finally {
        setIsUploading(false);
        setTimeout(() => {
          setUploadProgress(0);
        }, 1000);
      }
    } else {
      // Handle file upload
      if (!selectedVideo) {
        setUploadError("Please select a video file");
        return;
      }

      if (!USERID) {
        setUploadError("User ID is missing. Please login again.");
        return;
      }

      setIsUploading(true);
      setUploadProgress(0);
      setUploadError("");

      try {
        const formData = new FormData();
        formData.append("video", selectedVideo);
        formData.append("user_id", USERID);
        if (OrgID) {
          formData.append("org_id", OrgID);
        }
        const cleanedPortfolioTitle = sanitizePortfolioTitleInline(String(videoTitle || "")).trim();
        const cleanedPortfolioDesc = sanitizePortfolioDescriptionInline(String(videoDescription || "")).trim();
        if (cleanedPortfolioTitle && !isValidPortfolioTitle(cleanedPortfolioTitle)) {
          setUploadError(
            "Portfolio title can contain letters, numbers, spaces, and separators like ., -, _."
          );
          setIsUploading(false);
          return;
        }
        if (!isValidPortfolioDescription(cleanedPortfolioDesc)) {
          setUploadError(
            "Portfolio description should be meaningful text. Numbers and common special characters are allowed."
          );
          setIsUploading(false);
          return;
        }
        if (cleanedPortfolioTitle) {
          formData.append("title", cleanedPortfolioTitle);
        }
        if (cleanedPortfolioDesc) {
          formData.append("description", cleanedPortfolioDesc);
        }

        // Simulate progress (since fetch doesn't support progress natively)
        const progressInterval = setInterval(() => {
          setUploadProgress(prev => Math.min(prev + 10, 90));
        }, 200);

        const response = await fetch(`${baseurl}/profile/content/video/upload`, {
          method: "POST",
          body: formData,
        });

        clearInterval(progressInterval);
        setUploadProgress(100);

        const data = await response.json();
        
        if (data.status === true) {
          // Success - reset form
          setSelectedVideo(null);
          setVideoTitle("");
          setVideoDescription("");
          setUploadProgress(0);
          setShowVideoUploadModal(false);
          // Reset file input
          if (videoInputRef.current) {
            videoInputRef.current.value = "";
          }
          // Refresh videos list
          await fetchProfileVideos();
          showToast("Video uploaded successfully!");
        } else {
          setUploadError(data.description || "Failed to upload video. Please try again.");
        }
      } catch (error) {
        console.error("Error uploading video:", error);
        setUploadError("An error occurred while uploading the video: " + error.message);
      } finally {
        setIsUploading(false);
        setTimeout(() => {
          setUploadProgress(0);
        }, 1000);
      }
    }
  };


  const cancelVideoUpload = () => {
    setSelectedVideo(null);
    setSelectedDocument(null);
    setVideoTitle("");
    setVideoDescription("");
    setVideoSource("upload");
    setYoutubeUrl("");
    setUploadError("");
    setUploadProgress(0);
    setIsUploading(false);
    setShowVideoUploadModal(false);
    if (videoInputRef.current) videoInputRef.current.value = "";
    if (documentInputRef.current) documentInputRef.current.value = "";
  };

  const downloadFile = async (url, filename) => {
    try {
      // Use backend proxy endpoint to avoid CORS issues
      const proxyUrl = `${baseurl}/resume/download?url=${encodeURIComponent(url)}&filename=${encodeURIComponent(filename || 'resume.docx')}`;
      
      // Fetch the file through proxy and create blob for download
      const response = await fetch(proxyUrl);
      
      if (!response.ok) {
        throw new Error('Failed to download file');
      }
      
      // Get the blob from response
      const blob = await response.blob();
      
      // Create object URL from blob
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Create an anchor element for download
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename || 'resume.docx';
      link.style.display = 'none';
      
      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up the blob URL after a short delay
      setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl);
      }, 100);
    } catch (error) {
      console.error("Error downloading file:", error);
      // Fallback: try direct download via proxy URL
      const proxyUrl = `${baseurl}/resume/download?url=${encodeURIComponent(url)}&filename=${encodeURIComponent(filename || 'resume.docx')}`;
      window.open(proxyUrl, '_blank');
      throw error;
    }
  };

  const handleGenerateResume = async () => {
    const normalizedJobInput = sanitizeAlphaSpaceInline(jobInput || "").trim();

    if (!normalizedJobInput) {
      showToast("Please enter the job title", "error");
      return;
    }

    // Allow only alphabets and spaces.
    if (!/^[A-Za-z\s]+$/.test(normalizedJobInput)) {
      showToast("Only alphabets and spaces are allowed", "error");
      return;
    }

    if (profileCompleted !== null && profileCompleted !== 100) {
      showToast("Update your profile", "error");
      return;
    }

    if (!USERID) {
      showToast("User ID is missing. Please login again.", "error");
      return;
    }

    setIsGeneratingResume(true);

    try {
      const response = await fetch(`${baseurl}/resume/generate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: USERID,
          org_id: OrgID || "",
          job_description: normalizedJobInput,
        }),
      });

      const data = await response.json();

      if (data.status === true && data.data && data.data.resume_url) {
        // Download the resume file automatically
        const generatedResumeUrl = data.data.resume_url;
        
        // Format filename: username_resume_date.docx
        const username = personalInfo.fullName 
          ? personalInfo.fullName.trim().replace(/\s+/g, '_').toLowerCase() 
          : 'user';
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD
        const filename = `${username}_resume_${formattedDate}.docx`;

        // If user has no uploaded resume yet, surface generated resume in Resume section.
        if (!resumeUrl) {
          setResumeUrl(generatedResumeUrl);
          setResumeFileName(filename);
          setResumeUploadDate(currentDate.toISOString());
        }
        
        // Close modal first
        setShowGenerateResumeModal(false);
        setJobInput("");
        
        // Download the file
        try {
          await downloadFile(generatedResumeUrl, filename);
          showToast("Resume generated and downloaded successfully!");
        } catch (downloadError) {
          console.error("Error downloading resume:", downloadError);
          // Fallback: use proxy URL directly
          const proxyUrl = `${baseurl}/resume/download?url=${encodeURIComponent(generatedResumeUrl)}&filename=${encodeURIComponent(filename)}`;
          window.open(proxyUrl, '_blank');
          showToast("Resume generated successfully! The download should start in a new tab.");
        }
      } else {
        showToast("Failed to generate resume: " + (data.message || data.description || "Unknown error"), "error");
      }
    } catch (error) {
      console.error("Error generating resume:", error);
      showToast("An error occurred while generating the resume: " + error.message, "error");
    } finally {
      setIsGeneratingResume(false);
    }
  };

  const formatDateOnly = (value) => {
    const v = String(value ?? "").trim();
    if (!v) return "";
    if (v.includes("T")) return v.split("T")[0];
    const d = new Date(v);
    if (!Number.isNaN(d.getTime())) return d.toISOString().slice(0, 10);
    return v;
  };


  if (loading) {
    return <Loader />;
  }

  // Same name source as Dashboard
  const displayName = userStatus === "succeeded" && userDetails?.Username
    ? userDetails.Username
    : UserName || personalInfo.fullName || "";

  // Use profile_completion and goals_completion (0-100) from /banner/data/retrive
  const profilePct = typeof profileCompleted === "number" ? profileCompleted : 0;
  const goalPct = typeof goalCompleted === "number" ? goalCompleted : 0;
  // Green only at 100%, red when incomplete (< 100%)
  const isComplete = (pct) => pct === 100;
  const isPartial = (pct) => pct < 100;
  const getBannerClass = (pct) => isComplete(pct) ? style.profileBannerComplete : style.profileBannerIncomplete;
  const getIconColor = (pct) => isComplete(pct) ? "#22c55e" : "#dc2626";
  const getGoalIconColor = (pct) => isComplete(pct) ? "#22c55e" : "#dc2626";

  return (
    <div className={style.container} ref={pageRootRef}>
      <div className={style.profileSection}>
        <div className={style.header}>
          <div className={style.headerMenuSlot}>
            {typeof onMenuToggle === "function" && (
              <button
                type="button"
                className={style.mobileHeaderMenuBtn}
                onClick={onMenuToggle}
                aria-label="Open menu"
              >
                <MdMoreVert size={22} />
              </button>
            )}
          </div>
          <h1 className={style.profileHeadline}>{displayName ? `${displayName} Profile` : "Profile"}</h1>
          <div className={style.completionIconsRow}>
            <div
              className={style.completionIconWrap}
              title={`Profile: ${profilePct}% ${isPartial(profilePct) ? "Incomplete" : "Complete"}`}
            >
              <MdPerson
                className={style.completionIcon}
                style={{ color: getIconColor(profilePct) }}
                size={24}
              />
              <div className={`${style.completionTooltip} ${isPartial(profilePct) ? style.completionTooltipProgress : style.completionTooltipSuccess}`}>
                <div className={style.completionTooltipHeader}>
                  <span className={style.completionTooltipLabel}>Profile</span>
                  {isPartial(profilePct) ? (
                    <MdWarning className={style.completionTooltipIcon} style={{ color: "#dc2626" }} />
                  ) : (
                    <AiFillCheckCircle className={style.completionTooltipIcon} style={{ color: "#22c55e" }} />
                  )}
                </div>
                <div className={style.completionTooltipBar}>
                  <div
                    className={style.completionTooltipBarFill}
                    style={{
                      width: `${profilePct}%`,
                      background: isPartial(profilePct) ? "linear-gradient(90deg, #dc2626, #ef4444)" : "linear-gradient(90deg, #22c55e, #4ade80)",
                    }}
                  />
                </div>
                <div className={`${style.completionTooltipStatus} ${isPartial(profilePct) ? style.completionTooltipStatusProgress : style.completionTooltipStatusSuccess}`}>
                  <span className={style.completionTooltipPercent}>{profilePct}%</span>
                  <span className={style.completionTooltipText}>{isPartial(profilePct) ? "Incomplete" : "Complete"}</span>
                </div>
              </div>
            </div>
            <div
              className={style.completionIconWrap}
              title={`Goals: ${goalPct}% ${isPartial(goalPct) ? "Incomplete" : "Complete"}`}
            >
              <MdFlag
                className={style.completionIcon}
                style={{ color: getGoalIconColor(goalPct) }}
                size={24}
              />
              <div className={`${style.completionTooltip} ${isPartial(goalPct) ? style.completionTooltipProgress : style.completionTooltipSuccess}`}>
                <div className={style.completionTooltipHeader}>
                  <span className={style.completionTooltipLabel}>Goals</span>
                  {isPartial(goalPct) ? (
                    <MdWarning className={style.completionTooltipIcon} style={{ color: "#dc2626" }} />
                  ) : (
                    <AiFillCheckCircle className={style.completionTooltipIcon} style={{ color: "#22c55e" }} />
                  )}
                </div>
                <div className={style.completionTooltipBar}>
                  <div
                    className={style.completionTooltipBarFill}
                    style={{
                      width: `${goalPct}%`,
                      background: isPartial(goalPct) ? "linear-gradient(90deg, #dc2626, #ef4444)" : "linear-gradient(90deg, #22c55e, #4ade80)",
                    }}
                  />
                </div>
                <div className={`${style.completionTooltipStatus} ${isPartial(goalPct) ? style.completionTooltipStatusProgress : style.completionTooltipStatusSuccess}`}>
                  <span className={style.completionTooltipPercent}>{goalPct}%</span>
                  <span className={style.completionTooltipText}>{isPartial(goalPct) ? "Incomplete" : "Complete"}</span>
                </div>
              </div>
            </div>
          </div>
          <div className={style.headerActions}>
            <div className={style.shareProfileWrap}>
              <button
                type="button"
                className={style.shareProfileButton}
                onClick={async (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  let url = `${appUrl}/profile/${USERID || ""}`;
                  if (baseurl && USERID) {
                    try {
                      const token = localStorage.getItem("access-token");
                      let bearer = token;
                      if (token && typeof token === "string" && token.startsWith("{")) {
                        try {
                          const parsed = JSON.parse(token);
                          bearer = parsed?.token ?? parsed ?? token;
                        } catch {
                          bearer = token;
                        }
                      }
                      const res = await fetch(`${baseurl}/referral/link`, {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          ...(bearer && { Authorization: `Bearer ${bearer}` }),
                        },
                        body: JSON.stringify({
                          user_id: USERID,
                          asset_category: "PROFILE",
                          asset_id: USERID,
                        }),
                      });
                      const data = await res.json();
                      if (data.status && data.data?.referral_code) {
                        url = `${url}?ref=${data.data.referral_code}`;
                      }
                    } catch (err) {
                      console.warn("Referral link fetch failed:", err);
                    }
                  }
                  setSharedProfileUrl(url);
                  try {
                    await navigator.clipboard.writeText(url);
                    showToast("Profile link copied!");
                    setSharePopoverOpen(true);
                    setTimeout(() => setSharePopoverOpen(false), 3500);
                  } catch {
                    showToast("Copy failed. Link: " + url.substring(0, 50) + "...", "error");
                  }
                }}
                title="Copy shareable profile link"
              >
                <MdShare size={18} /> Share Profile
              </button>
              {sharePopoverOpen && sharedProfileUrl && (
                <div className={style.shareProfilePopover}>
                  <span className={style.shareProfilePopoverLabel}>Profile link copied</span>
                  <a
                    href={sharedProfileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={style.shareProfileLink}
                  >
                    {sharedProfileUrl}
                  </a>
                </div>
              )}
            </div>
            <button className={style.generateResumeButton} onClick={() => {
              setShowGenerateResumeModal(true);
            }}>
              Generate Resume
            </button>
          </div>
        </div>

        {profileCompleted !== null && !(!isPartial(profilePct) && profileBannerDismissed) && (
          <div className={`${style.profileBanner} ${getBannerClass(profilePct)}`}>
            {isPartial(profilePct) ? (
              <MdWarning className={style.profileBannerIcon} />
            ) : (
              <AiFillCheckCircle className={style.profileBannerIcon} />
            )}
            <span className={style.profileBannerText}>
              {isPartial(profilePct) ? "Your profile is incomplete" : "Your profile is complete"}
            </span>
            {!isPartial(profilePct) ? (
              <button
                className={style.profileBannerClose}
                onClick={() => {
                  setProfileBannerDismissed(true);
                  localStorage.setItem(`profileBannerDismissed_${USERID}`, "true");
                }}
                aria-label="Dismiss"
              >
                <MdClose size={20} />
              </button>
            ) : (
              <button
                className={style.profileBannerButton}
                onClick={() => setActiveTab("Bio")}
              >
                Update
              </button>
            )}
          </div>
        )}

        {goalCompleted !== null && !(!isPartial(goalPct) && goalBannerDismissed) && (
          <div className={`${style.profileBanner} ${getBannerClass(goalPct)}`}>
            {isPartial(goalPct) ? (
              <MdWarning className={style.profileBannerIcon} />
            ) : (
              <AiFillCheckCircle className={style.profileBannerIcon} />
            )}
            <span className={style.profileBannerText}>
              {isPartial(goalPct) ? "Your goal is incomplete" : "Your goal is complete"}
            </span>
            {isPartial(goalPct) ? (
            <button
              className={style.profileBannerButton}
              onClick={() => setShowGoalsPopup(true)}
            >
              Update
            </button>
            ) : (
              <button
                className={style.profileBannerClose}
                onClick={() => {
                  setGoalBannerDismissed(true);
                  localStorage.setItem(`goalBannerDismissed_${USERID}`, "true");
                }}
                aria-label="Dismiss"
              >
                <MdClose size={20} />
              </button>
            )}
          </div>
        )}

        <div className={style.tabs}>
          <button
            className={`${style.tab} ${activeTab === "Bio" ? style.activeTab : ""}`}
            onClick={() => setActiveTabPreserveScroll("Bio")}
          >
            Bio
          </button>
          <button
            className={`${style.tab} ${activeTab === "Skills" ? style.activeTab : ""}`}
            onClick={() => setActiveTabPreserveScroll("Skills")}
          >
            Skills
          </button>
          <button
            className={`${style.tab} ${activeTab === "Experience" ? style.activeTab : ""}`}
            onClick={() => setActiveTabPreserveScroll("Experience")}
          >
            Experience
          </button>
          <button
            className={`${style.tab} ${activeTab === "Portfolio" ? style.activeTab : ""}`}
            onClick={() => setActiveTabPreserveScroll("Portfolio")}
          >
            Portfolio
          </button>
          {/* <button
            className={`${style.tab} ${activeTab === "Account" ? style.activeTab : ""}`}
            onClick={() => setActiveTab("Account")}
          >
            Account
          </button> */}
        </div>

        {activeTab === "Bio" && (
          <div className={style.tabContent}>
            <div className={style.personalInfoRight}>
              <div className={style.formGrid}>
                <div className={style.formGroupFull}>
                  <div className={style.imageUploadSection}>
                    {profileImagePreview || profileImageUrl ? (
                      <div className={style.imagePreview}>
                        <img 
                          src={profileImagePreview || resolveImageSrc(profileImageUrl)} 
                          alt="Profile preview" 
                          className={style.profileImage}
                          key={`profile-img-${USERID || 'none'}`}
                        />
                        <button
                          type="button"
                          className={style.changeImageButton}
                          onClick={() => imageInputRef.current?.click()}
                        >
                          Change Image
                        </button>
                      </div>
                    ) : (
                      <div
                        className={style.imageUploadArea}
                        onClick={() => imageInputRef.current?.click()}
                      >
                        <div className={style.uploadPlaceholder}>
                          <span>Click to upload profile image</span>
                          <span className={style.uploadHint}>JPEG or PNG (max 5MB)</span>
                        </div>
                      </div>
                    )}
                    <input
                      ref={imageInputRef}
                      type="file"
                      accept="image/jpeg,image/jpg,image/png"
                      onChange={handleImageUpload}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>

                <div className={style.formGroupFull}>
                  <label className={style.label}>
                    Full Name <span className={style.required}>*</span>
                  </label>
                  <input
                    type="text"
                    className={style.input}
                    value={personalInfo.fullName}
                    onChange={(e) => {
                      const next = sanitizeFullName(e.target.value);
                      setPersonalInfo({ ...personalInfo, fullName: next });
                    }}
                  />
                </div>

                <div className={style.formGroup}>
                  <label className={style.label}>
                    Email <AiOutlineInfoCircle className={style.infoIcon} />
                  </label>
                  <input
                    type="email"
                    className={style.input}
                    value={personalInfo.email}
                    onChange={(e) => {
                      setPersonalInfo({ ...personalInfo, email: e.target.value });
                    }}
                  />
                </div>

                <div className={style.formGroup}>
                  <label className={style.label}>Phone</label>
                  <div className={style.phoneInput}>
                    <select
                      className={style.countryCode}
                      value={personalInfo.phoneCountryCode}
                      onChange={(e) =>
                        setPersonalInfo({
                          ...personalInfo,
                          phoneCountryCode: e.target.value,
                        })
                      }
                    >
                      <option value="+91">🇮🇳 +91</option>
                      <option value="+1">🇺🇸 +1</option>
                      <option value="+44">🇬🇧 +44</option>
                    </select>
                    <input
                      type="tel"
                      className={style.input}
                      value={personalInfo.phone}
                      onChange={(e) => {
                        const next = sanitizePhone10(e.target.value);
                        setPersonalInfo({ ...personalInfo, phone: next });
                      }}
                    />
                  </div>
                </div>

                <div className={style.formGroup}>
                  <label className={style.label}>
                    City <span className={style.required}>*</span>
                  </label>
                  <input
                    type="text"
                    className={style.input}
                    value={personalInfo.city}
                    onChange={(e) => {
                      const next = sanitizeCity(e.target.value);
                      setPersonalInfo({ ...personalInfo, city: next });
                    }}
                  />
                </div>

                <div className={style.formGroup}>
                  <label className={style.label}>
                    Country <span className={style.required}>*</span>
                  </label>
                  <select
                    className={style.input}
                    value={personalInfo.country}
                    onChange={(e) =>
                      setPersonalInfo({ ...personalInfo, country: e.target.value })
                    }
                  >
                    <option value="">Select country</option>
                    <option value="India">India</option>
                    <option value="United States">United States</option>
                    <option value="United Kingdom">United Kingdom</option>
                  </select>
                </div>

                <div className={style.formGroupFull}>
                  <h2 className={style.sectionTitle}>Links</h2>
                </div>

                <div className={style.formGroup}>
                  <label className={style.label}>Name</label>
                  <input
                    type="text"
                    className={style.input}
                    placeholder="Ex: LinkedIn, GitHub, Portfolio"
                    value={links.name}
                    onChange={(e) =>
                      handleLinkChange("name", e.target.value)
                    }
                  />
                </div>
                <div className={style.formGroup}>
                  <label className={style.label}>Link</label>
                  <input
                    type="text"
                    inputMode="url"
                    autoComplete="url"
                    className={style.input}
                    placeholder="https://example.com"
                    value={links.url}
                    onChange={(e) =>
                      handleLinkChange("url", e.target.value)
                    }
                  />
                </div>

              </div>
            </div>

            <div className={style.section}>
              <div className={style.formGroup}>
                <div className={style.labelRow}>
                  <label className={style.label}>Summary</label>
                  {summary.trim() && !isSummaryEditing && (
                    <button
                      type="button"
                      className={style.editSummaryBtn}
                      onClick={() => setIsSummaryEditing(true)}
                      aria-label="Edit summary"
                    >
                      <MdEdit className={style.editSummaryIcon} />
                      Edit
                    </button>
                  )}
                </div>
                <textarea
                  className={style.textarea}
                  placeholder="Profile Summary"
                  value={summary}
                  onChange={(e) => setSummary(e.target.value)}
                  rows={5}
                  readOnly={summary.trim() !== "" && !isSummaryEditing}
                />
              </div>
            </div>

            <div className={style.section}>
              <div className={style.formGroupFull}>
                <label className={style.label}>
                  Resume <span className={style.required}>*</span>
                </label>
                <div className={style.resumeUploadSection}>
                  {resumeFile || resumeUrl ? (
                    <div 
                      className={`${style.uploadArea} ${style.uploadAreaHasFile}`}
                    >
                      <div className={style.uploadedFile}>
                        <div className={style.checkIcon}>
                          <MdCheck />
                        </div>
                        <div
                          className={style.fileName}
                          title={resumeFileName || "Resume uploaded"}
                        >
                          {resumeFileName || "Resume uploaded"}
                        </div>
                        {resumeUploadDate && (
                          <div className={style.uploadDate}>
                            Uploaded on {formatDateOnly(resumeUploadDate)}
                          </div>
                        )}
                        {resumeUrl && (
                          <a
                            href={resumeUrl}
                            className={style.resumeLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              if (!resumeUrl) return;
                              openResumeInNewTab(resumeUrl, resumeFileName || "resume");
                            }}
                          >
                            View resume
                          </a>
                        )}
                        <div className={style.resumeActionRow}>
                          <button
                            type="button"
                            className={style.resumeActionBtn}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleReplaceResume();
                            }}
                          >
                            Replace resume
                          </button>
                          <button
                            type="button"
                            className={`${style.resumeActionBtn} ${style.resumeRemoveBtn}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveResume();
                            }}
                          >
                            Remove resume
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      className={style.uploadArea}
                      onClick={() => fileInputRef.current?.click()}
                    >
                      <div className={style.uploadPlaceholder}>
                        <div className={style.uploadIcon}>
                          <MdAdd style={{ fontSize: '3rem', color: '#595BDB' }} />
                        </div>
                        <div className={style.uploadText}>
                          <strong>Click to upload resume</strong>
                          <span className={style.uploadHint}>
                            Supported formats: PDF, DOC, DOCX
                          </span>
                          <span className={style.uploadHint}>
                            Maximum file size: 10MB
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".pdf,.doc,.docx"
                    onChange={handleFileUpload}
                    style={{ display: "none" }}
                  />
                </div>
              </div>
            </div>

            <div className={style.section}>
              <h2 className={style.sectionTitle}>Education</h2>
              {education.map((edu) => (
                <div key={edu.id} className={style.educationEntry}>
                  <div className={style.entryHeader}>
                    <h3 className={style.entryTitle}>
                      {edu.degree || "Degree"} from {edu.school || "School"}
                    </h3>
                    <button
                      className={style.removeButton}
                      onClick={() => removeEducation(edu.id)}
                    >
                      <MdClose /> Remove
                    </button>
                  </div>
                  <div className={style.formGrid}>
                    <div className={style.formGroup}>
                      <label className={style.label}>School</label>
                      <input
                        type="text"
                        className={style.input}
                        value={edu.school}
                        onChange={(e) =>
                          handleEducationChange(edu.id, "school", e.target.value)
                        }
                      />
                    </div>
                    <div className={style.formGroup}>
                      <label className={style.label}>Degree</label>
                      <input
                        type="text"
                        className={style.input}
                        value={edu.degree}
                        onChange={(e) =>
                          handleEducationChange(edu.id, "degree", e.target.value)
                        }
                      />
                    </div>
                    <div className={style.formGroup}>
                      <label className={style.label}>Start year</label>
                      <select
                        className={style.input}
                        value={edu.startYear}
                        onChange={(e) =>
                          handleEducationChange(edu.id, "startYear", e.target.value)
                        }
                      >
                        <option value="">Select year</option>
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className={style.formGroup}>
                      <label className={style.label}>End year</label>
                      <select
                        className={style.input}
                        value={edu.endYear}
                        onChange={(e) =>
                          handleEducationChange(edu.id, "endYear", e.target.value)
                        }
                      >
                        <option value="">Select year</option>
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className={style.formGroup}>
                      <label className={style.label}>Major</label>
                      <input
                        type="text"
                        className={style.input}
                        placeholder="Ex: Computer Science"
                        value={edu.major}
                        onChange={(e) =>
                          handleEducationChange(edu.id, "major", e.target.value)
                        }
                      />
                    </div>
                    <div className={style.formGroup}>
                      <label className={style.label}>GPA</label>
                      <input
                        type="text"
                        className={style.input}
                        placeholder="Ex: 3.9"
                        value={edu.gpa}
                        onChange={(e) => {
                          const next = sanitizeGpaInput(e.target.value);
                          handleEducationChange(edu.id, "gpa", next);
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}
              <button className={style.addButton} onClick={addEducation}>
                + Add Education
              </button>
            </div>

            {/* <div className={style.section} data-work-experience-section>
              <h2 className={style.sectionTitle}>Work Experience</h2>
              {workExperience.map((exp) => (
                <div key={exp.id} className={style.workExperienceEntry}>
                  <div className={style.entryHeader}>
                    <h3 className={style.entryTitle}>Work Experience</h3>
                    <button
                      className={style.removeButton}
                      onClick={() => removeWorkExperience(exp.id)}
                    >
                      <MdClose /> Remove
                    </button>
                  </div>
                  <div className={style.formGrid}>
                    <div className={style.formGroup}>
                      <label className={style.label}>Company</label>
                      <input
                        type="text"
                        className={style.input}
                        placeholder="Ex: Microsoft"
                        value={exp.company}
                        onChange={(e) =>
                          handleWorkExperienceChange(exp.id, "company", e.target.value)
                        }
                      />
                    </div>
                    <div className={style.formGroup}>
                      <label className={style.label}>Role</label>
                      <input
                        type="text"
                        className={style.input}
                        placeholder="Ex: Software Engineer"
                        value={exp.role}
                        onChange={(e) =>
                          handleWorkExperienceChange(exp.id, "role", e.target.value)
                        }
                      />
                    </div>
                    <div className={style.formGroup}>
                      <label className={style.label}>Start year</label>
                      <select
                        className={style.input}
                        value={exp.startYear}
                        onChange={(e) =>
                          handleWorkExperienceChange(exp.id, "startYear", e.target.value)
                        }
                      >
                        <option value="">Select year</option>
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className={style.formGroup}>
                      <label className={style.label}>End year</label>
                      <select
                        className={style.input}
                        value={exp.endYear}
                        onChange={(e) =>
                          handleWorkExperienceChange(exp.id, "endYear", e.target.value)
                        }
                      >
                        <option value="">Select year</option>
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className={style.formGroup}>
                      <label className={style.label}>City</label>
                      <input
                        type="text"
                        className={style.input}
                        placeholder="Ex: San Francisco"
                        value={exp.city}
                        onChange={(e) =>
                          handleWorkExperienceChange(exp.id, "city", e.target.value)
                        }
                      />
                    </div>
                    <div className={style.formGroup}>
                      <label className={style.label}>Country</label>
                      <select
                        className={style.input}
                        value={exp.country}
                        onChange={(e) =>
                          handleWorkExperienceChange(exp.id, "country", e.target.value)
                        }
                      >
                        <option value="">Ex: United States of America</option>
                        <option value="United States">United States</option>
                        <option value="India">India</option>
                        <option value="United Kingdom">United Kingdom</option>
                      </select>
                    </div>
                    <div className={style.formGroupFull}>
                      <label className={style.label}>Description</label>
                      <textarea
                        className={style.textarea}
                        placeholder="Ex: At Microsoft, I collaborated with..."
                        value={exp.description}
                        onChange={(e) =>
                          handleWorkExperienceChange(exp.id, "description", e.target.value)
                        }
                      />
                    </div>
                  </div>
                </div>
              ))}
              <button className={style.addButton} onClick={addWorkExperience}>
                + Add Work Experience
              </button>
            </div> */}

            <div className={style.section}>
              <h2 className={style.sectionTitle}>Projects</h2>
              {projects.map((proj) => (
                <div key={proj.id} className={style.projectEntry}>
                  <div className={style.entryHeader}>
                    <h3 className={style.entryTitle}>Project</h3>
                    <button
                      className={style.removeButton}
                      onClick={() => removeProject(proj.id)}
                    >
                      <MdClose /> Remove
                    </button>
                  </div>
                  <div className={style.formGrid}>
                    <div className={style.formGroupFull}>
                      <label className={style.label}>Project Name</label>
                      <input
                        type="text"
                        className={style.input}
                        value={proj.projectName}
                        onChange={(e) =>
                          handleProjectChange(proj.id, "projectName", e.target.value)
                        }
                      />
                    </div>
                    <div className={style.formGroup}>
                      <label className={style.label}>Start year</label>
                      <select
                        className={style.input}
                        value={proj.startYear}
                        onChange={(e) =>
                          handleProjectChange(proj.id, "startYear", e.target.value)
                        }
                      >
                        <option value="">Select year</option>
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className={style.formGroup}>
                      <label className={style.label}>End year</label>
                      <select
                        className={style.input}
                        value={proj.endYear}
                        onChange={(e) =>
                          handleProjectChange(proj.id, "endYear", e.target.value)
                        }
                      >
                        <option value="">Select year</option>
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className={style.formGroupFull}>
                      <label className={style.label}>Description</label>
                      <textarea
                        className={style.textarea}
                        value={proj.description}
                        onChange={(e) =>
                          handleProjectChange(proj.id, "description", e.target.value)
                        }
                      />
                    </div>
                  </div>
                </div>
              ))}
              <button className={style.addButton} onClick={addProject}>
                + Add Project
              </button>
            </div>

            <div className={style.actionButtons}>
              <button className={style.cancelButton} onClick={handleCancel}>
                Cancel
              </button>
              <button className={style.saveButton} onClick={handleSave}>
                Save
              </button>
            </div>
          </div>
        )}

        {activeTab === "Skills" && (
          <div className={style.tabContent}>
            <div className={style.section}>
              {/* Skills Header with Add icon */}
              <div className={style.skillsHeader}>
                <h2 className={style.skillsHeaderTitle}>Skills</h2>
                <div className={style.skillsHeaderActions} style={{ marginLeft: "0.25rem" }}>
                  <button 
                    className={style.skillsHeaderButton}
                    onClick={addSkillEntry}
                    title="Add skill"
                  >
                    <MdAdd />
                  </button>
                </div>
              </div>

              {/* Skills - Display mode (read-only) or Edit mode (form fields) */}
              <div className={style.skillsListContainer}>
              {skills.map((skill, index) => (
                <div 
                  key={skill.id} 
                  ref={index === skills.length - 1 ? lastSkillRef : null}
                  className={editingSkillId === skill.id ? style.workExperienceEntry : style.skillListItem}
                  style={editingSkillId === skill.id ? { cursor: "text" } : undefined}
                >
                  {editingSkillId === skill.id ? (
                    <>
                      <div className={style.entryHeader}>
                        <h3 className={style.entryTitle}>Skill</h3>
                        <div className={style.entryHeaderActions}>
                          <button
                            className={style.skillsHeaderButton}
                            onClick={() => setEditingSkillId(null)}
                            title="Disable editing"
                          >
                            <MdEdit />
                          </button>
                          <button
                            className={style.removeButton}
                            onClick={() => removeSkillEntry(skill.id)}
                            title="Remove skill"
                          >
                            <MdClose /> Remove
                          </button>
                        </div>
                      </div>
                      <div className={style.formGrid}>
                        <div className={style.formGroup}>
                          <label className={style.label}>Title</label>
                          <input
                            type="text"
                            className={style.input}
                            placeholder="Ex: JavaScript, Python, Project Management"
                            value={skill.title}
                            onChange={(e) =>
                              handleSkillChange(skill.id, "title", e.target.value)
                            }
                          />
                        </div>
                        <div className={style.formGroupFull}>
                          <label className={style.label}>Description</label>
                          <textarea
                            className={style.textarea}
                            placeholder="Ex: Proficient in building web applications..."
                            value={skill.description}
                            onChange={(e) =>
                              handleSkillChange(skill.id, "description", e.target.value)
                            }
                          />
                        </div>
                      </div>
                      <div className={style.entrySaveRow}>
                        <button className={style.saveButton} onClick={handleSaveSkills}>
                          Save
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className={style.skillListItemContent}>
                      <div className={style.skillNameRow}>
                        <span className={style.skillName}>{skill.title || "Untitled"}</span>
                        <div className={style.skillCardActions} style={{ marginLeft: "auto" }}>
                          <button
                            className={style.skillsHeaderButton}
                            onClick={() => setEditingSkillId(skill.id)}
                            title="Edit skill"
                          >
                            <MdEdit />
                          </button>
                          <button
                            className={style.removeButton}
                            onClick={() => removeSkillEntry(skill.id)}
                            title="Remove skill"
                          >
                            <MdClose /> Remove
                          </button>
                        </div>
                      </div>
                      {skill.description && (
                        <p className={style.skillExperienceText}>{skill.description}</p>
                      )}
                    </div>
                  )}
                </div>
              ))}
              </div>

              {/* Empty State */}
              {skills.length === 0 && (
                <button
                  type="button"
                  className={style.emptySkillsState}
                  onClick={addSkillEntry}
                  title="Add your first skill"
                >
                  <div className={style.emptySkillsIcon}>
                    <MdAdd />
                  </div>
                  <p className={style.emptySkillsText}>No skills added yet</p>
                  <p className={style.emptySkillsSubtext}>Add your first skill above to get started</p>
                </button>
              )}

              {editingSkillId && skills.length > 0 && (
                <div className={style.actionButtons}>
                  <button className={style.cancelButton} onClick={() => setEditingSkillId(null)}>
                    Cancel
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {activeTab === "Experience" && (
          <div className={style.tabContent}>
            <div className={style.section}>
              {/* Work Experience Header with Add icon */}
              <div className={style.skillsHeader}>
                <h2 className={style.skillsHeaderTitle}>Work Experience</h2>
                <div className={style.skillsHeaderActions} style={{ marginLeft: "0.25rem" }}>
                  <button 
                    className={style.skillsHeaderButton}
                    onClick={addWorkExperience}
                    title="Add work experience"
                  >
                    <MdAdd />
                  </button>
                </div>
              </div>

              {/* Work Experience Form Entries */}
              {workExperience.map((exp, index) => (
                <div 
                  key={exp.id} 
                  ref={index === workExperience.length - 1 ? lastExperienceRef : null}
                  className={style.workExperienceEntry}
                  style={{ cursor: isEditingExperience ? 'text' : 'default' }}
                >
                  <div className={style.entryHeader}>
                    <div className={style.entryHeaderActions} style={{ marginLeft: "auto" }}>
                      <button
                        className={style.skillsHeaderButton}
                        onClick={() => setIsEditingExperience(!isEditingExperience)}
                        title={isEditingExperience ? "Disable editing" : "Edit experience"}
                      >
                        <MdEdit />
                      </button>
                      <button
                        className={style.removeButton}
                        onClick={() => removeWorkExperience(exp.id)}
                        title="Remove experience"
                      >
                        <MdClose /> Remove
                      </button>
                    </div>
                  </div>
                  <div 
                    className={style.formGrid} 
                    onClick={() => { 
                      if (!isEditingExperience) {
                        setIsEditingExperience(true);
                        if (index === 0) setTimeout(() => companyInputRef.current?.focus(), 50);
                      }
                    }}
                    style={{ cursor: isEditingExperience ? 'default' : 'pointer' }}
                  >
                    <div className={style.formGroup}>
                      <label className={style.label}>Company</label>
                      <input
                        ref={index === 0 ? companyInputRef : null}
                        type="text"
                        className={style.input}
                        placeholder="Ex: Microsoft"
                        value={exp.company}
                        disabled={!isEditingExperience}
                        onChange={(e) =>
                          handleWorkExperienceChange(exp.id, "company", e.target.value)
                        }
                      />
                    </div>
                    <div className={style.formGroup}>
                      <label className={style.label}>Role</label>
                      <input
                        type="text"
                        className={style.input}
                        placeholder="Ex: Software Engineer"
                        value={exp.role}
                        disabled={!isEditingExperience}
                        onChange={(e) =>
                          handleWorkExperienceChange(exp.id, "role", e.target.value)
                        }
                      />
                    </div>
                    <div className={style.formGroup}>
                      <label className={style.label}>Start year</label>
                      <select
                        className={style.input}
                        value={exp.startYear}
                        disabled={!isEditingExperience}
                        onChange={(e) =>
                          handleWorkExperienceChange(exp.id, "startYear", e.target.value)
                        }
                      >
                        <option value="">Select year</option>
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className={style.formGroup}>
                      <label className={style.label}>End year</label>
                      <select
                        className={style.input}
                        value={exp.endYear}
                        disabled={!isEditingExperience}
                        onChange={(e) =>
                          handleWorkExperienceChange(exp.id, "endYear", e.target.value)
                        }
                      >
                        <option value="">Select year</option>
                        <option value="Present">Present</option>
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className={style.formGroup}>
                      <label className={style.label}>City</label>
                      <input
                        type="text"
                        className={style.input}
                        placeholder="Ex: San Francisco"
                        value={exp.city}
                        disabled={!isEditingExperience}
                        onChange={(e) =>
                          handleWorkExperienceChange(exp.id, "city", e.target.value)
                        }
                      />
                    </div>
                    <div className={style.formGroup}>
                      <label className={style.label}>Country</label>
                      <select
                        className={style.input}
                        value={exp.country}
                        disabled={!isEditingExperience}
                        onChange={(e) =>
                          handleWorkExperienceChange(exp.id, "country", e.target.value)
                        }
                      >
                        <option value="">Ex: United States of America</option>
                        <option value="United States">United States</option>
                        <option value="India">India</option>
                        <option value="United Kingdom">United Kingdom</option>
                      </select>
                    </div>
                    <div className={style.formGroupFull}>
                      <label className={style.label}>Description</label>
                      <textarea
                        className={style.textarea}
                        placeholder="Ex: At Microsoft, I collaborated with..."
                        value={exp.description}
                        disabled={!isEditingExperience}
                        onChange={(e) =>
                          handleWorkExperienceChange(exp.id, "description", e.target.value)
                        }
                      />
                    </div>
                  </div>
                  {isEditingExperience && (
                    <div className={style.entrySaveRow}>
                      <button className={style.saveButton} onClick={handleSaveExperience}>
                        Save
                      </button>
                    </div>
                  )}
                </div>
              ))}
              {workExperience.length === 0 && (
                <button
                  type="button"
                  className={style.emptySkillsState}
                  onClick={addWorkExperience}
                  title="Add your first work experience"
                >
                  <div className={style.emptySkillsIcon}>
                    <MdAdd />
                  </div>
                  <p className={style.emptySkillsText}>No work experience added yet</p>
                  <p className={style.emptySkillsSubtext}>Add your first work experience above to get started</p>
                </button>
              )}

              {isEditingExperience && workExperience.length > 0 && (
                <div className={style.actionButtons}>
                  <button className={style.cancelButton} onClick={handleCancel}>
                    Cancel
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {activeTab === "Portfolio" && (
          <div className={style.tabContent}>
            <div className={style.portfolioWrapper}>
              {/* Portfolio Hero */}
              <div className={style.portfolioHero}>
                <div className={style.portfolioHeroContent}>
                  <h2 className={style.portfolioTitle}>Your Works</h2>
                  <p className={style.portfolioSubtitle}>
                    Showcase your work with videos and documents. Build a compelling narrative that highlights your expertise.
                  </p>
                  <div className={style.portfolioStats}>
                    <div className={style.portfolioStat}>
                      <MdPlayCircle className={style.portfolioStatIcon} />
                      <span className={style.portfolioStatValue}>{videos.length}</span>
                      <span className={style.portfolioStatLabel}>Videos</span>
                    </div>
                    <div className={style.portfolioStat}>
                      <MdInsertDriveFile className={style.portfolioStatIcon} />
                      <span className={style.portfolioStatValue}>{documents.length}</span>
                      <span className={style.portfolioStatLabel}>Documents</span>
                    </div>
                  </div>
                </div>
                <button 
                  className={style.addStoryButton}
                  onClick={() => setShowVideoUploadModal(true)}
                  title="Add Portfolio Item"
                >
                  <MdAdd /> Add Portfolio Item
                </button>
              </div>

              <div className={style.section}>
              {/* Video Upload Modal */}
              {showVideoUploadModal && (
                <div className={style.modalOverlay} onClick={(e) => {
                  if (e.target === e.currentTarget && !isUploading) {
                    cancelVideoUpload();
                  }
                }}>
                  <div className={style.videoUploadModal} onClick={(e) => e.stopPropagation()}>
                    <div className={style.addStoryModalHeader}>
                      <div className={style.addStoryModalHeaderAccent} />
                      <div className={style.addStoryModalHeaderContent}>
                        <div className={style.addStoryModalHeaderIcon}>
                          <MdPlayCircle />
                        </div>
                        <div>
                          <h3 className={style.addStoryModalTitle}>Add Story</h3>
                          <p className={style.addStoryModalSubtitle}>Upload a video, document, or add a YouTube link</p>
                        </div>
                      </div>
                      <button
                        className={style.addStoryModalClose}
                        onClick={cancelVideoUpload}
                        disabled={isUploading}
                        title="Close"
                      >
                        <MdClose />
                      </button>
                    </div>
                    <div className={style.addStoryModalBody}>
                      {/* Form Fields Section - Show First */}
                      <div className={style.videoUploadForm}>
                        <div className={style.formGroup}>
                          <label className={style.label}>Title (Optional)</label>
                          <input
                            type="text"
                            className={style.input}
                            placeholder="Enter video title"
                            value={videoTitle}
                            onChange={(e) => setVideoTitle(sanitizePortfolioTitleInline(e.target.value))}
                            disabled={isUploading}
                          />
                        </div>
                        <div className={style.formGroupFull}>
                          <label className={style.label}>Description (Optional)</label>
                          <textarea
                            className={style.textarea}
                            placeholder="Enter video description"
                            value={videoDescription}
                            onChange={(e) => setVideoDescription(sanitizePortfolioDescriptionInline(e.target.value))}
                            rows={3}
                            disabled={isUploading}
                          />
                        </div>
                      </div>

                      {/* Video Upload Section */}
                      <div className={style.videoUploadSection}>
                        <div className={style.uploadHeader}>
                          <div className={style.uploadHeaderIcon}><MdPlayCircle /></div>
                          <h3 className={style.uploadTitle}>Upload Video or Document</h3>
                        </div>

                        {/* Video File Upload Area */}
                        <div
                          className={`${style.uploadArea} ${selectedVideo ? style.uploadAreaSelected : ""} ${isUploading ? style.uploadAreaUploading : ""}`}
                          onClick={() => !isUploading && videoInputRef.current?.click()}
                          style={{ cursor: isUploading ? 'not-allowed' : 'pointer' }}
                        >
                          {isUploading ? (
                            <div className={style.uploadProgressContainer}>
                              <div className={style.uploadProgressBar}>
                                <div 
                                  className={style.uploadProgressFill}
                                  style={{ width: `${uploadProgress}%` }}
                                ></div>
                              </div>
                              <p className={style.uploadProgressText}>
                                Uploading... {uploadProgress}%
                              </p>
                            </div>
                          ) : selectedVideo ? (
                            <div className={style.uploadedFile}>
                              <div className={style.checkIcon}>
                                <MdCheck />
                              </div>
                              <div className={style.fileName}>{selectedVideo.name}</div>
                              <div className={style.uploadDate}>
                                {(selectedVideo.size / (1024 * 1024)).toFixed(2)} MB
                              </div>
                              <button
                                className={style.changeFileButton}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  videoInputRef.current?.click();
                                }}
                              >
                                Change File
                              </button>
                            </div>
                          ) : (
                            <div className={style.uploadPlaceholder}>
                              <div className={style.uploadIcon}>
                                <MdPlayCircle style={{ fontSize: '3rem', color: '#0EA5E9' }} />
                              </div>
                              <div className={style.uploadText}>
                                <strong>Click to upload video</strong>
                                <span className={style.uploadHint}>
                                  Supported formats: MP4, MOV, AVI, MKV, WEBM, FLV, WMV, M4V
                                </span>
                                <span className={style.uploadHint}>
                                  Maximum file size: 100MB
                                </span>
                              </div>
                            </div>
                          )}
                          <input
                            ref={videoInputRef}
                            type="file"
                            accept="video/mp4,video/mov,video/avi,video/mkv,video/webm,video/flv,video/wmv,video/m4v"
                            onChange={handleVideoUpload}
                            disabled={isUploading}
                            style={{ display: "none" }}
                          />
                        </div>

                        {/* Document Upload Area */}
                        <div
                          className={`${style.uploadArea} ${selectedDocument ? style.uploadAreaSelected : ""} ${isUploading ? style.uploadAreaUploading : ""}`}
                          onClick={() => !isUploading && documentInputRef.current?.click()}
                          style={{ cursor: isUploading ? 'not-allowed' : 'pointer', marginTop: '1rem' }}
                        >
                          {isUploading && selectedDocument ? (
                            <div className={style.uploadProgressContainer}>
                              <div className={style.uploadProgressBar}>
                                <div
                                  className={style.uploadProgressFill}
                                  style={{ width: `${uploadProgress}%` }}
                                ></div>
                              </div>
                              <p className={style.uploadProgressText}>
                                Uploading... {uploadProgress}%
                              </p>
                            </div>
                          ) : selectedDocument ? (
                            <div className={style.uploadedFile}>
                              <div className={style.checkIcon}>
                                <MdCheck />
                              </div>
                              <div className={style.fileName}>{selectedDocument.name}</div>
                              <div className={style.uploadDate}>
                                {(selectedDocument.size / 1024).toFixed(1)} KB
                              </div>
                              <button
                                className={style.changeFileButton}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  documentInputRef.current?.click();
                                }}
                              >
                                Change File
                              </button>
                            </div>
                          ) : (
                            <div className={style.uploadPlaceholder}>
                              <div className={style.uploadIcon}>
                                <MdInsertDriveFile style={{ fontSize: '3rem', color: '#0EA5E9' }} />
                              </div>
                              <div className={style.uploadText}>
                                <strong>Click to upload document</strong>
                                <span className={style.uploadHint}>
                                  Supported formats: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT
                                </span>
                              </div>
                            </div>
                          )}
                          <input
                            ref={documentInputRef}
                            type="file"
                            accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
                            onChange={handleDocumentUpload}
                            disabled={isUploading}
                            style={{ display: "none" }}
                          />
                        </div>

                        {/* Divider */}
                        <div className={style.divider}>
                          <span>OR</span>
                        </div>

                        {/* YouTube Link Section */}
                        <div className={style.youtubeInputSection}>
                          <label className={style.label}>
                            Add YouTube Link
                          </label>
                          <input
                            type="url"
                            className={style.input}
                            placeholder="https://www.youtube.com/watch?v=... or https://youtu.be/..."
                            value={youtubeUrl}
                            onChange={(e) => {
                              setYoutubeUrl(e.target.value);
                              setUploadError("");
                              // Clear selected video/document when YouTube URL is entered
                              if (e.target.value.trim()) {
                                setSelectedVideo(null);
                                setSelectedDocument(null);
                                setVideoSource("youtube");
                                if (videoInputRef.current) videoInputRef.current.value = "";
                                if (documentInputRef.current) documentInputRef.current.value = "";
                              }
                            }}
                            disabled={isUploading}
                          />
                          <p className={style.youtubeHint}>
                            Paste your YouTube video URL here. Supports standard YouTube links.
                          </p>
                          {youtubeUrl && validateYouTubeUrl(youtubeUrl).valid && (
                            <div className={style.youtubePreview}>
                              <div className={style.youtubePreviewLabel}>Preview:</div>
                              <iframe
                                width="100%"
                                height="315"
                                src={convertToYouTubeEmbedUrl(youtubeUrl)}
                                title="YouTube video preview"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                style={{ borderRadius: '8px', marginTop: '0.5rem' }}
                              ></iframe>
                            </div>
                          )}
                        </div>

                        {uploadError && (
                          <div className={style.uploadError}>
                            <span className={style.errorIcon}>⚠️</span>
                            <span>{uploadError}</span>
                            <button 
                              className={style.errorClose}
                              onClick={() => setUploadError("")}
                            >
                              ×
                            </button>
                          </div>
                        )}
                      </div>

                      {/* Action Buttons */}
                      <div className={style.actionButtons}>
                        <button 
                          className={style.cancelButton} 
                          onClick={cancelVideoUpload}
                          disabled={isUploading}
                        >
                          Cancel
                        </button>
                        <button 
                          className={style.saveButton} 
                          onClick={uploadVideo}
                          disabled={isUploading || (!selectedVideo && !selectedDocument && (!youtubeUrl || !validateYouTubeUrl(youtubeUrl).valid))}
                        >
                          {isUploading ? (
                            <>
                              <span className={style.uploadSpinner}></span>
                              {youtubeUrl && validateYouTubeUrl(youtubeUrl).valid ? "Adding..." : "Uploading..."}
                            </>
                          ) : (
                            youtubeUrl && validateYouTubeUrl(youtubeUrl).valid
                              ? "Add YouTube Video"
                              : selectedDocument
                                ? "Upload Document"
                                : "Upload Video"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Stories and Documents - Two columns like reference */}
              <div className={style.portfolioContent}>
                {/* Stories Section */}
                <div className={style.portfolioSection}>
                  <div className={style.portfolioSectionHeader}>
                    <div>
                      <h3 className={style.portfolioSectionTitle}>Stories</h3>
                    </div>
                    {videos.length > 4 && !showAllVideos && (
                      <button type="button" className={style.portfolioViewAll} onClick={() => setShowAllVideos(true)}>
                        View All →
                      </button>
                    )}
                    {videos.length > 4 && showAllVideos && (
                      <button type="button" className={style.portfolioViewAll} onClick={() => setShowAllVideos(false)}>
                        Show Less
                      </button>
                    )}
                  </div>
                  {videos.length > 0 ? (
                    <div className={style.storiesGrid}>
                      {(showAllVideos ? videos : videos.slice(0, 4)).map((video, index) => {
                        const videoKey = `v-${index}`;
                        const mediaUrl = video.file_url || video.video_url;
                        const isYoutube = video.is_youtube || (video.description && video.description.includes('[YOUTUBE]')) || (mediaUrl && mediaUrl.includes('youtube.com/embed'));
                        const inlineYoutubeUrl = isYoutube && mediaUrl
                          ? `${mediaUrl}${mediaUrl.includes('?') ? '&' : '?'}autoplay=${hoveredYoutubeKey === videoKey ? '1' : '0'}&mute=1&controls=1&rel=0&modestbranding=1&playsinline=1&fs=1`
                          : mediaUrl;
                        const watchUrl = isYoutube && mediaUrl ? (() => {
                          const match = mediaUrl.match(/embed\/([^?]+)/);
                          return match ? `https://www.youtube.com/watch?v=${match[1]}` : mediaUrl;
                        })() : mediaUrl;
                        return (
                          <div
                            key={videoKey}
                            role="button"
                            tabIndex={0}
                            className={style.storyCard}
                            onClick={() => {
                              if (isYoutube && watchUrl) {
                                window.open(watchUrl, "_blank", "noopener,noreferrer");
                                return;
                              }
                              setStoryVideoModal({ video, mediaUrl, isYoutube });
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                if (isYoutube && watchUrl) {
                                  window.open(watchUrl, "_blank", "noopener,noreferrer");
                                  return;
                                }
                                setStoryVideoModal({ video, mediaUrl, isYoutube });
                              }
                            }}
                            onMouseEnter={() => {
                              if (isYoutube) {
                                setHoveredYoutubeKey(videoKey);
                              } else {
                                storyVideoRefs.current[videoKey]?.play();
                              }
                            }}
                            onMouseLeave={() => {
                              if (isYoutube) {
                                setHoveredYoutubeKey((prev) => (prev === videoKey ? null : prev));
                              } else {
                                storyVideoRefs.current[videoKey]?.pause();
                              }
                            }}
                          >
                            <div className={style.storyCardThumb}>
                              {isYoutube ? (
                                <iframe src={inlineYoutubeUrl} title={video.title || "YouTube"} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowFullScreen></iframe>
                              ) : (
                                <video
                                  ref={(el) => { storyVideoRefs.current[videoKey] = el; }}
                                  preload="auto"
                                  muted
                                  loop
                                  controls
                                  playsInline
                                  onClick={(e) => e.stopPropagation()}
                                  onMouseDown={(e) => e.stopPropagation()}
                                  onDoubleClick={(e) => e.stopPropagation()}
                                >
                                  <source src={mediaUrl} type="video/mp4" />
                                </video>
                              )}
                              <div className={style.storyPlayOverlay}><MdPlayCircle /></div>
                            </div>
                            <div className={style.storyCardInfo}>
                              <div className={style.storyCardTitleRow}>
                                <h4 className={style.storyCardTitle}>{video.title || "Untitled"}</h4>
                                <div className={style.storyCardActions}>
                                  <button
                                    type="button"
                                    className={style.storyCardActionBtn}
                                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleEditVideo(video); }}
                                    title="Edit"
                                  >
                                    <MdEdit />
                                  </button>
                                  <button
                                    type="button"
                                    className={style.storyCardActionBtn}
                                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDeleteVideo(video); }}
                                    title="Delete"
                                  >
                                    <MdDelete />
                                  </button>
                                </div>
                              </div>
                              <p className={style.storyCardMeta}>
                                {video.file_size_mb ? `${Math.round(video.file_size_mb * 2)} min` : "Video"} • {isYoutube ? "YouTube" : "Video"}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div className={style.portfolioSectionEmpty} onClick={() => setShowVideoUploadModal(true)}>
                      <MdPlayCircle className={style.portfolioSectionEmptyIcon} />
                      <p>No stories yet. Add your first video.</p>
                    </div>
                  )}
                </div>

                {/* Documents Section */}
                <div className={style.portfolioSection}>
                  <div className={style.portfolioSectionHeader}>
                    <div>
                      <h3 className={style.portfolioSectionTitle}>Documents</h3>
                    </div>
                    {documents.length > 3 && !showAllDocuments && (
                      <button type="button" className={style.portfolioViewAll} onClick={() => setShowAllDocuments(true)}>
                        View All →
                      </button>
                    )}
                    {documents.length > 3 && showAllDocuments && (
                      <button type="button" className={style.portfolioViewAll} onClick={() => setShowAllDocuments(false)}>
                        Show Less
                      </button>
                    )}
                  </div>
                  {documents.length > 0 ? (
                    <div className={style.documentsList}>
                      {(showAllDocuments ? documents : documents.slice(0, 3)).map((doc, index) => {
                        const ext = (doc.file_name || '').split('.').pop()?.toUpperCase() || 'DOC';
                        const tagClass = ext === 'PDF' ? style.documentListTagPdf 
                          : (ext === 'DOC' || ext === 'DOCX') ? style.documentListTagDoc 
                          : (ext === 'XLS' || ext === 'XLSX') ? style.documentListTagXls 
                          : (ext === 'PPT' || ext === 'PPTX') ? style.documentListTagPpt 
                          : style.documentListTagDoc;
                        const tagLabel = ext === 'PDF' ? 'PDF' : ext === 'DOC' || ext === 'DOCX' ? 'DOC' : ext === 'XLS' || ext === 'XLSX' ? 'XLS' : ext === 'PPT' || ext === 'PPTX' ? 'PPT' : ext;
                        const isDownloaded = downloadedDocUrls.has(doc.file_url);
                        const handleDownloadClick = (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          const a = document.createElement('a');
                          a.href = doc.file_url;
                          a.download = doc.file_name || 'document';
                          a.target = '_blank';
                          document.body.appendChild(a);
                          a.click();
                          document.body.removeChild(a);
                          setDownloadedDocUrls(prev => new Set([...prev, doc.file_url]));
                        };
                        return (
                          <div key={`d-${index}`} className={style.documentListItem}>
                            <div className={`${style.documentFileIcon} ${tagClass}`}>
                              <span className={style.documentFileIconLabel}>{tagLabel}</span>
                            </div>
                            <a href={doc.file_url} target="_blank" rel="noopener noreferrer" className={style.documentListMain}>
                              <div className={style.documentListInfo}>
                                <span className={style.documentListName}>{doc.file_name || doc.title || 'Document'}</span>
                                <span className={style.documentListSize}>
                                  {doc.file_size_mb != null && doc.file_size_mb > 0 ? `${(doc.file_size_mb).toFixed(1)} MB` : 'Document'}
                                </span>
                              </div>
                            </a>
                            <div className={style.documentListActions}>
                              <button
                                type="button"
                                className={style.documentListActionBtn}
                                onClick={() => handleRenameDocument(doc)}
                                title="Edit document name"
                              >
                                <MdEdit />
                              </button>
                              <button
                                type="button"
                                className={style.documentListActionBtn}
                                onClick={() => handleDeleteDocument(doc)}
                                title="Delete document"
                              >
                                <MdDelete />
                              </button>
                            {!isDownloaded && (
                              <button
                                type="button"
                                className={style.documentListDownloadBtn}
                                onClick={handleDownloadClick}
                                title="Download"
                              >
                                <MdDownload className={style.documentListDownload} />
                              </button>
                            )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div className={style.portfolioSectionEmpty} onClick={() => setShowVideoUploadModal(true)}>
                      <MdInsertDriveFile className={style.portfolioSectionEmptyIcon} />
                      <p>No documents yet. Add your first file.</p>
                    </div>
                  )}
                </div>
              </div>
              </div>
            </div>
          </div>
        )}

        {/* {activeTab === "Account" && (
          <div className={style.tabContent}>
            <h2 className={style.sectionTitle}>Account</h2>
            <p>Account settings will go here</p>
          </div>
        )} */}

        {/* Generate Resume Modal */}
        {showGenerateResumeModal && (
          <>
            <div className={style.generateResumeOverlay} onClick={(e) => {
              if (!isGeneratingResume) {
                setShowGenerateResumeModal(false);
                setJobInput("");
                setIsGeneratingResume(false);
              }
            }}></div>
            <div className={style.generateResumePopup} onClick={(e) => e.stopPropagation()}>
              <div className={style.generateResumeHeader}>
                <h3 className={style.generateResumeTitle}>Generate Resume</h3>
                <button
                  type="button"
                  className={style.generateResumeClose}
                  onClick={() => {
                    if (!isGeneratingResume) {
                      setShowGenerateResumeModal(false);
                      setJobInput("");
                    }
                  }}
                  disabled={isGeneratingResume}
                  aria-label="Close"
                >
                  <MdClose size={24} />
                </button>
              </div>
              <div className={style.generateResumeBody}>
                <div className={style.generateResumeFormGroup}>
                  <label className={style.generateResumeLabel}>
                    Enter the job role or description
                  </label>
                  <textarea
                    className={style.generateResumeTextarea}
                    placeholder="e.g., Software Engineer, Data Scientist, Product Manager"
                    value={jobInput}
                    onChange={(e) => setJobInput(sanitizeAlphaSpaceInline(e.target.value))}
                    rows={4}
                    disabled={isGeneratingResume}
                  />
                </div>
              </div>
              <div className={style.generateResumeActions}>
                <button 
                  className={style.generateResumeCancel} 
                  onClick={() => {
                    setShowGenerateResumeModal(false);
                    setJobInput("");
                    setIsGeneratingResume(false);
                  }}
                  disabled={isGeneratingResume}
                >
                  Cancel
                </button>
                <button 
                  className={style.generateResumeSubmit} 
                  onClick={handleGenerateResume}
                  disabled={!jobInput.trim() || isGeneratingResume}
                >
                  {isGeneratingResume ? (
                    "Generating..."
                  ) : (
                    "Generate"
                  )}
                </button>
              </div>
            </div>
          </>
        )}

        {docActionModal && (
          <div className={style.modalOverlay} onClick={() => setDocActionModal(null)}>
            <div className={style.documentActionModal} onClick={(e) => e.stopPropagation()}>
              <h3 className={style.documentActionTitle}>
                {docActionModal.type === "rename" ? "Edit Document Name" : "Delete Document"}
              </h3>
              {docActionModal.type === "rename" ? (
                <input
                  type="text"
                  className={style.input}
                  value={docNameInput}
                  onChange={(e) => setDocNameInput(sanitizeAlphaSpaceInline(e.target.value))}
                  placeholder="Enter document name"
                />
              ) : (
                <p className={style.documentActionText}>
                  Are you sure you want to delete this document?
                </p>
              )}
              <div className={style.documentActionButtons}>
                <button
                  type="button"
                  className={style.cancelButton}
                  onClick={() => setDocActionModal(null)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className={style.saveButton}
                  onClick={docActionModal.type === "rename" ? confirmRenameDocument : confirmDeleteDocument}
                >
                  {docActionModal.type === "rename" ? "Save" : "Delete"}
                </button>
              </div>
            </div>
          </div>
        )}

        {videoActionModal && (
          <div className={style.modalOverlay} onClick={() => setVideoActionModal(null)}>
            <div className={style.documentActionModal} onClick={(e) => e.stopPropagation()}>
              <h3 className={style.documentActionTitle}>
                {videoActionModal.type === "edit" ? "Edit Video Details" : "Delete Video"}
              </h3>
              {videoActionModal.type === "edit" ? (
                <>
                  <input
                    type="text"
                    className={style.input}
                    value={videoTitleInput}
                    onChange={(e) => setVideoTitleInput(sanitizePortfolioTitleInline(e.target.value))}
                    placeholder="Video title"
                  />
                  <textarea
                    className={style.textarea}
                    value={videoDescriptionInput}
                    onChange={(e) => setVideoDescriptionInput(sanitizePortfolioDescriptionInline(e.target.value))}
                    placeholder="Video description"
                    rows={3}
                  />
                </>
              ) : (
                <p className={style.documentActionText}>
                  Are you sure you want to delete this {((videoActionModal.video?.file_type || "") === "youtube") ? "YouTube link" : "video"}?
                </p>
              )}
              <div className={style.documentActionButtons}>
                <button
                  type="button"
                  className={style.cancelButton}
                  onClick={() => setVideoActionModal(null)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className={style.saveButton}
                  onClick={videoActionModal.type === "edit" ? confirmEditVideo : confirmDeleteVideo}
                >
                  {videoActionModal.type === "edit" ? "Save" : "Delete"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Story Video Player Modal - Big Screen */}
        {storyVideoModal && (
          <div
            className={style.modalOverlay}
            onClick={() => setStoryVideoModal(null)}
          >
            <div
              className={style.storyVideoModal}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                type="button"
                className={style.storyVideoModalClose}
                onClick={() => setStoryVideoModal(null)}
                aria-label="Close"
              >
                <MdClose size={28} />
              </button>
              <h3 className={style.storyVideoModalTitle}>{storyVideoModal.video.title || "Untitled"}</h3>
              <div className={style.storyVideoModalPlayer}>
                {storyVideoModal.isYoutube ? (
                  <iframe
                    src={storyVideoModal.mediaUrl}
                    title={storyVideoModal.video.title || "YouTube"}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                    allowFullScreen
                  />
                ) : (
                  <video controls autoPlay playsInline>
                    <source src={storyVideoModal.mediaUrl} type="video/mp4" />
                  </video>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      <GoalsPopup
        open={showGoalsPopup}
        onClose={() => setShowGoalsPopup(false)}
        onSuccess={fetchBannerData}
      />

      <ToastPopup
        show={toastPopup.show}
        message={toastPopup.message}
        type={toastPopup.type}
        onClose={closeToast}
      />
    </div>
  );
};

export default Profile;
